"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6558],{

/***/ 12587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43859);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57247);
/* harmony import */ var _Button_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39793);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  border-radius: 16px;\n  display: ",
        ";\n  width: ",
        ";\n  height: 44px;\n\n  & > button,\n  & > a {\n    flex: ",
        ";\n    height: 100%;\n  }\n\n  & > button + button,\n  & > a + a {\n    margin-left: 2px; // To avoid focus shadow overlap\n  }\n\n  & > button,\n  & a {\n    box-shadow: none;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// const getBackgroundColor = ({ theme, variant }: StyledButtonMenuProps) => {
//   return theme.colors[variant === variants.SUBTLE ? "input" : "tertiary"];
// };
var getBorderColor = function getBorderColor(param) {
    var theme = param.theme, variant = param.variant;
    return theme.colors[variant === variants.SUBTLE ? "inputSecondary" : "disabled"];
};
var StyledButtonMenu = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-39b27064-0"
}).withConfig({
    componentId: "sc-a44cb9c8-0"
})(_templateObject(), function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? "flex" : "inline-flex";
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? "100%" : "auto";
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : "auto";
}, function(param) {
    var disabled = param.disabled, theme = param.theme, variant = param.variant;
    if (disabled) {
        return "\n        opacity: 0.5;\n\n        & > button:disabled {\n          background-color: transparent;\n          color: ".concat(variant === _Button_types__WEBPACK_IMPORTED_MODULE_5__/* .variants.PRIMARY */ .o.PRIMARY ? theme.colors.primary : theme.colors.textSubtle, ";\n        }\n    ");
    }
    return "";
}, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
var ButtonMenu = function ButtonMenu(_param) {
    var _activeIndex = _param.activeIndex, activeIndex = _activeIndex === void 0 ? 0 : _activeIndex, _scale = _param.scale, scale = _scale === void 0 ? _Button_types__WEBPACK_IMPORTED_MODULE_5__/* .scales.MD */ .Q.MD : _scale, _variant = _param.variant, variant = _variant === void 0 ? _Button_types__WEBPACK_IMPORTED_MODULE_5__/* .variants.SECONDARY */ .o.SECONDARY : _variant, onItemClick = _param.onItemClick, disabled = _param.disabled, children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "activeIndex",
        "scale",
        "variant",
        "onItemClick",
        "disabled",
        "children",
        "fullWidth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButtonMenu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        disabled: disabled,
        variant: "primary",
        fullWidth: fullWidth
    }, props), {
        children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, index) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
                isActive: activeIndex === index,
                onClick: onItemClick ? function() {
                    return onItemClick(index);
                } : undefined,
                scale: scale,
                variant: variant,
                disabled: disabled
            });
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonMenu);


/***/ }),

/***/ 51983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43859);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98553);
/* harmony import */ var _Button_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39793);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  color: white;\n  font-size: 14px;\n\n  &:hover:not(:disabled):not(:active) {\n    background-color: #ffffff33;\n    color: white;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var InactiveButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1527820c-0"
}).withConfig({
    componentId: "sc-510a19d1-0"
})(_templateObject());
var ActiveButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1527820c-1"
}).withConfig({
    componentId: "sc-510a19d1-1"
})(_templateObject1());
var ButtonMenuItem = function ButtonMenuItem(_param) {
    var _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _variant = _param.variant, variant = _variant === void 0 ? _Button_types__WEBPACK_IMPORTED_MODULE_5__/* .variants.PRIMARY */ .o.PRIMARY : _variant, as = _param.as, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "isActive",
        "variant",
        "as"
    ]);
    if (!isActive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InactiveButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            forwardedAs: as,
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ActiveButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        as: as,
        variant: variant
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonMenuItem);


/***/ }),

/***/ 92052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Checkbox/types.ts
var scales = {
    SM: "sm",
    MD: "md"
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  height: ",
        ";\n  width: ",
        ";\n  vertical-align: middle;\n  transition: background-color 0.2s ease-in-out;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  background-color: transparent;\n  /* background-color: ",
        "; */\n  /* box-shadow: ",
        '; */\n\n  &:after {\n    content: "";\n    position: absolute;\n    border-bottom: 2px solid;\n    border-left: 2px solid;\n    border-color: transparent;\n    top: 30%;\n    left: 0;\n    right: 0;\n    width: 50%;\n    height: 25%;\n    margin: auto;\n    transform: rotate(-50deg);\n    transition: border-color 0.2s ease-in-out;\n  }\n\n  &:hover:not(:disabled):not(:checked) {\n    box-shadow: ',
        ";\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n\n  &:checked {\n    background-color: ",
        ";\n    &:after {\n      border-color: black;\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var getScale = function getScale(param) {
    var scale = param.scale;
    switch(scale){
        case scales.SM:
            return "16px";
        case scales.MD:
        default:
            return "32px";
    }
};
var Checkbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-17eaea42-0"
}).withConfig({
    componentId: "sc-77eeb8e-0"
})(_templateObject(), getScale, getScale, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
Checkbox.defaultProps = {
    scale: scales.MD
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);


/***/ }),

/***/ 63771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 66806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 3C8.03 3 4 7.03 4 12H2.20711C1.76165 12 1.53857 12.5386 1.85355 12.8536L4.54604 15.546C4.73751 15.7375 5.04662 15.7418 5.24329 15.5556L8.08805 12.8631C8.4164 12.5524 8.19646 12 7.74435 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.4314 19 9.98175 18.4782 8.81739 17.601C8.37411 17.267 7.74104 17.259 7.3486 17.6514C6.95725 18.0428 6.95413 18.6823 7.38598 19.0284C8.92448 20.2615 10.8708 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 8008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69589);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15426);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92052);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43859);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  padding-bottom: 24px;\n  padding-top: 24px;\n  border: none;\n  height: 59px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledModalHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cb1d6ec9-0"
})(_templateObject());
var GradientModalHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .ModalHeader */ .xB).withConfig({
    componentId: "sc-cb1d6ec9-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
// TODO: Copy from src/views/Predictions/components/RiskDisclaimer.tsx
// Will replace that with this modal.
var DisclaimerModal = function(param) {
    var id = param.id, onSuccess = param.onSuccess, onDismiss = param.onDismiss, checks = param.checks, header = param.header, subtitle = param.subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(checks || []), checkState = ref[0], setCheckState = ref[1];
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    var handleSetAcknowledgeRisk = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(currentKey) {
        var newCheckState = checkState.map(function(check) {
            if (currentKey === check.key) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, check), {
                    value: !check.value
                });
            }
            return check;
        });
        setCheckState(newCheckState);
    }, [
        checkState
    ]);
    var handleConfirm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        onSuccess();
        onDismiss();
    }, [
        onSuccess,
        onDismiss
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .ModalContainer */ .F0, {
        className: "modal-welcome",
        title: t("Welcome!"),
        $minWidth: "320px",
        id: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .ModalHeader */ .xB, {
                background: theme.colors.primary,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .ModalTitle */ .r6, {
                    color: "textMain",
                    children: t("Welcome")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .ModalBody */ .fe, {
                p: "16px 24px 24px",
                maxWidth: [
                    "100%",
                    "100%",
                    "100%",
                    "400px"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        maxHeight: "300px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                as: "h3",
                                mb: "8px",
                                style: {
                                    fontSize: "16px",
                                    fontWeight: 500
                                },
                                children: header
                            }),
                            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                as: "p",
                                color: "textSubtle",
                                mb: "16px",
                                style: {
                                    fontSize: "12px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "rgba(255, 255, 255, 0.6)"
                                    },
                                    children: subtitle
                                })
                            }),
                            checkState.map(function(check) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                    htmlFor: check.key,
                                    style: {
                                        display: "block",
                                        cursor: "pointer",
                                        marginBottom: "24px"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                style: {
                                                    flex: "none",
                                                    alignSelf: "flex-start"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    className: "".concat(check.value ? "checked" : ""),
                                                    id: check.key,
                                                    scale: "sm",
                                                    checked: check.value,
                                                    onChange: function() {
                                                        return handleSetAcknowledgeRisk(check.key);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                ml: "4px",
                                                children: check.content
                                            })
                                        ]
                                    })
                                }, check.key);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        id: "".concat(id, "-continue"),
                        width: "100%",
                        onClick: handleConfirm,
                        disabled: checkState.some(function(check) {
                            return !check.value;
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                fontWeight: 700
                            },
                            children: t("Confirm")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisclaimerModal);


/***/ }),

/***/ 69117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43859);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 8px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #ddd;\n  border-bottom: 8px solid #ddd;\n  width: 20px;\n  height: 20px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Loading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-57089fde-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 54757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ TabToggleGroup; },
/* harmony export */   "o": function() { return /* binding */ TabToggle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43859);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-x: scroll;\n  padding: 0;\n  border-radius: 8px 8px 0 0;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  scrollbar-width: none; /* Firefox */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  /* background-color: ",
        "; */\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  cursor: pointer;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  margin: 0;\n  border-radius: 8px 8px 0 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: ",
        ";\n  background-color: ",
        ";\n  box-shadow: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8e2a608b-0"
})(_templateObject());
var Inner = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8e2a608b-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var TabToggle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    as: "button"
}).withConfig({
    componentId: "sc-8e2a608b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.cardHeaderBg : theme.colors.darkGray;
});
TabToggle.defaultProps = {
    p: "16px"
};
var TabToggleGroup = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        p: [
            "0 4px",
            "0 16px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Inner, {
            children: children
        })
    });
};


/***/ }),

/***/ 49729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useCakeApprovalStatus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74836);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36963);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22408);




// TODO: refactor as useTokenApprovalStatus for generic use
var useCakeApprovalStatus = function(spender) {
    var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_1__/* .useWeb3React */ .Ge)().account;
    var ref = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useCake */ .kL)(), cakeContract = ref.reader;
    var key = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return account && spender ? {
            contract: cakeContract,
            methodName: "allowance",
            params: [
                account,
                spender
            ]
        } : null;
    }, [
        account,
        cakeContract,
        spender
    ]);
    var ref1 = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__/* .useSWRContract */ .Av)(key), data = ref1.data, mutate = ref1.mutate;
    return {
        isVaultApproved: data ? data.gt(0) : false,
        setLastUpdated: mutate
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCakeApprovalStatus);


/***/ }),

/***/ 71850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21046);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52775);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36963);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19237);
/* harmony import */ var hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85900);
/* harmony import */ var hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76431);
/* harmony import */ var components_Toast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96036);










var useCakeApprove = function(setLastUpdated, spender, successMsg) {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var toastSuccess = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* .useToast */ .p)().toastSuccess;
    var ref = (0,hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var ref1 = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useCake */ .kL)(), cakeContract = ref1.signer;
    // console.log('cakeContract', cakeContract)
    var handleApprove = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var receipt;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(cakeContract, "approve", [
                                    spender,
                                    _ethersproject_constants__WEBPACK_IMPORTED_MODULE_9__/* .MaxUint256 */ .Bz
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Toast__WEBPACK_IMPORTED_MODULE_5__/* .ToastDescriptionWithTx */ .Y, {
                                txHash: receipt.transactionHash,
                                children: successMsg
                            }));
                            setLastUpdated();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleApprove() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCakeApprove);


/***/ }),

/***/ 94186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nn": function() { return /* binding */ useGetCakeBalance; },
/* harmony export */   "nu": function() { return /* binding */ useGetBnbBalance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70655);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74836);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40370);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42918);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21046);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46472);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8100);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87318);
/* harmony import */ var utils_providers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62621);
/* harmony import */ var _useContract__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36963);
/* harmony import */ var _useSWRContract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22408);


















var useTokenBalance = function(tokenAddress, forceBSC) {
    var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_0__/* .useWeb3React */ .Ge)().account;
    var contract = (0,_useContract__WEBPACK_IMPORTED_MODULE_9__/* .useTokenContract */ .Ib)(tokenAddress, false);
    var key = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return account ? {
            contract: contract,
            methodName: "balanceOf",
            params: [
                account
            ]
        } : null;
    }, [
        account,
        contract,
        forceBSC
    ]);
    var _ref = (0,_useSWRContract__WEBPACK_IMPORTED_MODULE_10__/* .useSWRContract */ .Av)(key, {
        refreshInterval: config_constants__WEBPACK_IMPORTED_MODULE_3__/* .FAST_INTERVAL */ .sR
    }), data = _ref.data, status = _ref.status, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, [
        "data",
        "status"
    ]);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, rest), {
        fetchStatus: status,
        balance: data ? new (bignumber_js__WEBPACK_IMPORTED_MODULE_1___default())(data.toString()) : utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW
    });
};
var useGetBnbBalance = function() {
    var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_0__/* .useWeb3React */ .Ge)().account;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)([
        account,
        "ethBalance"
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            return [
                2,
                utils_providers__WEBPACK_IMPORTED_MODULE_8__/* .bscRpcProvider.getBalance */ .v.getBalance(account)
            ];
        });
    })), status = ref.status, data = ref.data, mutate = ref.mutate;
    return {
        balance: data || _ethersproject_constants__WEBPACK_IMPORTED_MODULE_16__/* .Zero */ ._Y,
        fetchStatus: status,
        refresh: mutate
    };
};
var useGetCakeBalance = function() {
    var ref, ref1;
    var chainId = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_0__/* .useWeb3React */ .Ge)().chainId;
    var ref2 = useTokenBalance(((ref = _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__/* .CAKE */ .cr[chainId]) === null || ref === void 0 ? void 0 : ref.address) || ((ref1 = _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__/* .CAKE */ .cr[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_4__/* .ChainId.BSC */ .a_.BSC]) === null || ref1 === void 0 ? void 0 : ref1.address), true), balance = ref2.balance, fetchStatus = ref2.fetchStatus;
    // console.log('CAKE', CAKE, chainId, balance, fetchStatus)
    // TODO: Remove ethers conversion once useTokenBalance is converted to ethers.BigNumber
    return {
        balance: _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_17__/* .BigNumber.from */ .O$.from(balance.toString()),
        fetchStatus: fetchStatus
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useTokenBalance);


/***/ }),

/***/ 13471:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ }),

/***/ 69241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SwiperContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var SwiperContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var SwiperProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var destroySwiper = function() {
        if (swiper) {
            swiper.destroy();
            setSwiper(null);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwiperContext.Provider, {
        value: {
            swiper: swiper,
            setSwiper: setSwiper,
            destroySwiper: destroySwiper
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SwiperProvider));


/***/ }),

/***/ 62682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XW": function() { return /* binding */ getRoundPosition; },
/* harmony export */   "jw": function() { return /* binding */ getMultiplierV2; },
/* harmony export */   "kJ": function() { return /* binding */ getPriceDifference; },
/* harmony export */   "o4": function() { return /* binding */ CHART_DOT_CLICK_EVENT; },
/* harmony export */   "pf": function() { return /* binding */ formatUsdv2; },
/* harmony export */   "rc": function() { return /* binding */ formatBnbv2; },
/* harmony export */   "tw": function() { return /* binding */ formatRoundTime; }
/* harmony export */ });
/* unused harmony export padTime */
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20335);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96470);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59123);
/* harmony import */ var utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13471);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21046);





var MIN_PRICE_BNB_DISPLAYED = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from("1000000000000000");
var formatPriceDifference = function(param) {
    var _price = param.price, price = _price === void 0 ? _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y : _price, minPriceDisplayed = param.minPriceDisplayed, unitPrefix = param.unitPrefix, displayedDecimals = param.displayedDecimals, decimals = param.decimals;
    if (price.abs().lt(minPriceDisplayed)) {
        var sign = price.isNegative() ? _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .NegativeOne */ .tL : _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .One */ .fh;
        var signedPriceToFormat = minPriceDisplayed.mul(sign);
        return "<".concat(unitPrefix).concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(signedPriceToFormat, displayedDecimals, decimals));
    }
    if ((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(price, displayedDecimals, decimals).includes("-")) {
        return "-".concat(unitPrefix).concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(price, displayedDecimals, decimals).slice(1));
    }
    return "".concat(unitPrefix).concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_1__/* .formatBigNumberToFixed */ .U1)(price, displayedDecimals, decimals));
};
var formatUsdv2 = function(usd, minPriceDisplayed, displayedDecimals) {
    return formatPriceDifference({
        price: usd,
        minPriceDisplayed: minPriceDisplayed,
        unitPrefix: "$",
        displayedDecimals: displayedDecimals,
        decimals: 8
    });
};
var formatBnbv2 = function(bnb, displayedDecimals) {
    return formatPriceDifference({
        price: bnb,
        minPriceDisplayed: MIN_PRICE_BNB_DISPLAYED,
        unitPrefix: "",
        displayedDecimals: displayedDecimals,
        decimals: 18
    });
};
var padTime = function(num) {
    return num.toString().padStart(2, "0");
};
var formatRoundTime = function(secondsBetweenBlocks) {
    var ref = (0,utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(secondsBetweenBlocks), hours = ref.hours, minutes = ref.minutes, seconds = ref.seconds;
    var minutesSeconds = "".concat(padTime(minutes), ":").concat(padTime(seconds));
    if (hours > 0) {
        return "".concat(padTime(hours), ":").concat(minutesSeconds);
    }
    return minutesSeconds;
};
var getMultiplierV2 = function(total, amount) {
    if (!total) {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(0);
    }
    if (total.eq(0) || amount.eq(0)) {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(0);
    }
    var rewardAmountFixed = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(total);
    var multiplierAmountFixed = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_5__/* .FixedNumber.from */ .xs.from(amount);
    return rewardAmountFixed.divUnsafe(multiplierAmountFixed);
};
var getPriceDifference = function(price, lockPrice) {
    if (!price || !lockPrice) {
        return _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y;
    }
    return price.sub(lockPrice);
};
var getRoundPosition = function(lockPrice, closePrice) {
    if (!closePrice) {
        return null;
    }
    if (closePrice.eq(lockPrice)) {
        return state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.HOUSE */ .Tu.HOUSE;
    }
    return closePrice.gt(lockPrice) ? state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.BULL */ .Tu.BULL : state_types__WEBPACK_IMPORTED_MODULE_0__/* .BetPosition.BEAR */ .Tu.BEAR;
};
var CHART_DOT_CLICK_EVENT = "CHART_DOT_CLICK_EVENT";


/***/ }),

/***/ 37408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36963);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22408);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21046);
/* harmony import */ var _context_ConfigProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65238);




var usePollOraclePrice = function() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var chainlinkOracleAddress = (0,_context_ConfigProvider__WEBPACK_IMPORTED_MODULE_2__/* .useConfig */ .ZR)().chainlinkOracleAddress;
    var chainlinkOracleContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_0__/* .useChainlinkOracleContract */ .Hn)(chainlinkOracleAddress, false);
    // Can refactor to subscription later
    var ref = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_1__/* .useSWRContract */ .Av)([
        chainlinkOracleContract,
        "latestAnswer"
    ], {
        refreshInterval: seconds * 1000,
        refreshWhenHidden: true,
        refreshWhenOffline: true,
        dedupingInterval: seconds * 1000,
        fallbackData: _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y
    }), price = ref.data, mutate = ref.mutate;
    return {
        price: price,
        refresh: mutate
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePollOraclePrice);


/***/ }),

/***/ 82961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_SwiperProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69241);


var useSwiper = function() {
    var swiperContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_SwiperProvider__WEBPACK_IMPORTED_MODULE_1__/* .SwiperContext */ .O);
    if (swiperContext === undefined) {
        throw new Error("Swiper not found");
    }
    return swiperContext;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSwiper);


/***/ }),

/***/ 46558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_Predictions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 2 modules
var src = __webpack_require__(74836);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var hooks = __webpack_require__(88770);
// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./src/state/predictions/hooks.ts + 2 modules
var predictions_hooks = __webpack_require__(89890);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/useLocalDispatch.ts
var useLocalDispatch = __webpack_require__(29807);
// EXTERNAL MODULE: ./src/state/global/actions.ts
var actions = __webpack_require__(51904);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
;// CONCATENATED MODULE: ./src/hooks/useAccountLocalEventListener.ts




var useAccountLocalEventListener = function() {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId, connector = ref.connector;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    (0,react.useEffect)(function() {
        if (account && connector) {
            var handleEvent = function() {
                dispatch((0,actions/* resetUserState */.t)({
                    chainId: chainId
                }));
            };
            connector.addListener("disconnect", handleEvent);
            connector.addListener("change", handleEvent);
            return function() {
                connector.removeListener("disconnect", handleEvent);
                connector.removeListener("change", handleEvent);
            };
        }
        return undefined;
    }, [
        account,
        chainId,
        dispatch,
        connector
    ]);
};

// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(63970);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(92052);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
;// CONCATENATED MODULE: ./src/views/Predictions/components/ChartDisclaimer.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  list-style-position: outside;\n  margin-left: 16px;\n\n  & > li {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 851px) {\n    max-width: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Ul = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-d16980a7-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ModalBody1 = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalBody */.fe).withConfig({
    componentId: "sc-d16980a7-1"
})(_templateObject1());
var ChartDisclaimer = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChartDisclaimerShow */.TL)(), 2), showDisclaimer = ref[0], setShowDisclaimer = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleConfirm = function() {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        className: "trading-view-modal",
        $minWidth: "320px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody1, {
            p: "24px",
            maxWidth: "400px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "center",
                    mb: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/predictions/chartwarning22.svg",
                        width: 183,
                        height: 75
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    fontSize: "16px",
                    fontWeight: 700,
                    children: [
                        t("Warning"),
                        ": ",
                        t("Prices shown on cards and charts are different"),
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "12px",
                    mt: 2,
                    mb: "24px",
                    style: {
                        color: "rgba(255, 255, 255, 0.6)"
                    },
                    children: [
                        t("The price you see comes from difference places"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ul, {
                    style: {
                        color: "rgba(255, 255, 255, 0.6)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                fontSize: 12
                            },
                            children: t("Prices on cards come from Chainlink’s verifiable price oracle.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                fontSize: 12
                            },
                            children: t("Prices on charts come from Binance.com. Chart's are provided for your reference only.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    mb: "16px",
                    fontSize: "12px",
                    color: "textSubtle",
                    style: {
                        color: "rgba(255, 255, 255, 0.6)"
                    },
                    children: t("Only the price from Chainlink (shown on the cards) determines the round's result.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.mummy.finance/prediction",
                    external: true,
                    mb: "16px",
                    color: "primary",
                    children: t("Learn More")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: handleConfirm,
                        mb: "16px",
                        children: t("I understand")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: "checkbox",
                    style: {
                        display: "block",
                        cursor: "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    flex: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    id: "checkbox",
                                    scale: "sm",
                                    checked: !showDisclaimer,
                                    onChange: function() {
                                        return setShowDisclaimer(!showDisclaimer);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "8px",
                                children: t("Don't show this again")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ChartDisclaimer = (ChartDisclaimer);

;// CONCATENATED MODULE: ./src/views/Predictions/components/ChainlinkChartDisclaimer.tsx


function ChainlinkChartDisclaimer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  list-style-position: outside;\n  margin-left: 16px;\n\n  & > li {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n"
    ]);
    ChainlinkChartDisclaimer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChainlinkChartDisclaimer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 851px) {\n    max-width: unset;\n  }\n"
    ]);
    ChainlinkChartDisclaimer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ChainlinkChartDisclaimer_Ul = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e2318274-0"
})(ChainlinkChartDisclaimer_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ChainlinkChartDisclaimer_ModalBody1 = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalBody */.fe).withConfig({
    componentId: "sc-e2318274-1"
})(ChainlinkChartDisclaimer_templateObject1());
var ChainlinkChartDisclaimer_ChartDisclaimer = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChainlinkChartDisclaimerShow */.sg)(), 2), showDisclaimer = ref[0], setShowDisclaimer = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleConfirm = function() {
        onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        className: "oracle-chart-modal",
        $minWidth: "320px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChainlinkChartDisclaimer_ModalBody1, {
            p: "24px",
            maxWidth: "400px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "center",
                    mb: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/predictions/chartwarning21.svg",
                        width: 133,
                        height: 62
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "16px",
                    fontWeight: 700,
                    children: t("Currently showing charts from Chainlink oracle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "12px",
                    mt: 2,
                    mb: "24px",
                    style: {
                        color: "rgba(255, 255, 255, 0.6)"
                    },
                    children: t("The price you see comes directly from the Chainlink oracle, which powers the Prediction game.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChainlinkChartDisclaimer_Ul, {
                    style: {
                        color: "rgba(255, 255, 255, 0.6)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                fontSize: 12
                            },
                            children: t("Oracle price refreshes every ~20 seconds.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                fontSize: 12
                            },
                            children: t("In comparison with the TradingView chart, this chart refreshes slower and with fewer features.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        scale: "md",
                        width: "100%",
                        variant: "success",
                        onClick: handleConfirm,
                        my: "16px",
                        style: {
                            fontSize: 14
                        },
                        children: t("I understand")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: "checkbox",
                    style: {
                        display: "block",
                        cursor: "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    flex: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    id: "checkbox",
                                    scale: "sm",
                                    checked: !showDisclaimer,
                                    onChange: function() {
                                        return setShowDisclaimer(!showDisclaimer);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: 12,
                                ml: "8px",
                                children: t("Don't show this again")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ChainlinkChartDisclaimer = (ChainlinkChartDisclaimer_ChartDisclaimer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrophyGold.tsx
var TrophyGold = __webpack_require__(56658);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(81641);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(79279);
// EXTERNAL MODULE: ./src/views/Predictions/context/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(65238);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(85900);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/state/predictions/config.ts
var config = __webpack_require__(81272);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/utils/helperToast.tsx
var helperToast = __webpack_require__(36706);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/helpers.ts


var formatUsd = function(usd, displayedDecimals) {
    return "$".concat((0,formatBalance/* formatNumber */.uf)(usd || 0, displayedDecimals, displayedDecimals));
};
var formatUsdPro = function(usd, displayedDecimals) {
    var showPlus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (usd < 0) {
        return "-$".concat(Math.abs(usd).toFixed(displayedDecimals));
    }
    var result = "$".concat(usd.toFixed(displayedDecimals));
    if (showPlus) {
        result = "+".concat(result);
    }
    return result;
};
var formatBnbPro = function(bnb, displayedDecimals) {
    var showPlus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (bnb < 0) {
        return "-".concat(Math.abs(bnb).toFixed(displayedDecimals));
    }
    var result = bnb.toFixed(displayedDecimals);
    if (showPlus) {
        result = "+".concat(result);
    }
    return result;
};
var formatBnb = function(bnb, displayedDecimals) {
    return bnb ? bnb.toLocaleString(undefined, {
        minimumFractionDigits: displayedDecimals,
        maximumFractionDigits: displayedDecimals
    }) : "0";
};
var getMultiplier = function(total, amount) {
    if (total === 0 || amount === 0) {
        return 0;
    }
    return total / amount;
};
/**
 * Calculates the total payout given a bet
 */ var getPayout = function(bet) {
    var rewardRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!bet || !bet.round) {
        return 0;
    }
    var _round = bet.round, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount, totalAmount = _round.totalAmount;
    var multiplier = getMultiplier(totalAmount, bet.position === types/* BetPosition.BULL */.Tu.BULL ? bullAmount : bearAmount);
    return bet.amount * multiplier * rewardRate;
};
var getNetPayout = function(bet) {
    var rewardRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!bet || !bet.round) {
        return 0;
    }
    var payout = getPayout(bet, rewardRate);
    return payout - bet.amount;
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CupWinning.tsx
var CupWinning = __webpack_require__(59566);
;// CONCATENATED MODULE: ./src/views/Predictions/components/CollectRoundWinningsModal.tsx







function CollectRoundWinningsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n"
    ]);
    CollectRoundWinningsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectRoundWinningsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -116px; // line up bunny at the top of the modal\n  left: 0px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    CollectRoundWinningsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var Modal = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-615f9f7c-0"
})(CollectRoundWinningsModal_templateObject());
var BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-615f9f7c-1"
})(CollectRoundWinningsModal_templateObject1());
var calculateClaimableRounds = function(history) {
    if (!history) {
        return {
            epochs: [],
            total: 0
        };
    }
    return history.reduce(function(accum, bet) {
        if (!bet.claimed && bet.position === bet.round.position) {
            var betPayout = getPayout(bet, config/* REWARD_RATE */.Ck);
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, accum), {
                epochs: (0,_to_consumable_array/* default */.Z)(accum.epochs).concat([
                    bet.round.epoch
                ]),
                total: accum.total + betPayout
            });
        }
        return accum;
    }, {
        epochs: [],
        total: 0
    });
};
var CollectRoundWinningsModal = function(param) {
    var onDismiss = param.onDismiss, onSuccess = param.onSuccess, history = param.history, isLoadingHistory = param.isLoadingHistory, dispatch = param.dispatch, predictionsAddress = param.predictionsAddress, token = param.token, isV1Claim = param.isV1Claim, price = param.price;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, isPendingTx = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var bnbBusdPrice = (0,useBUSDPrice/* default */.ZP)(token);
    var ref1 = calculateClaimableRounds(history), epochs = ref1.epochs, total = ref1.total;
    // const totalBnb = multiplyPriceByAmount(bnbBusdPrice, total)
    var totalBnb = price ? parseFloat((0,formatBalance/* formatBigNumberToFixed */.U1)(price, 4, 8)) * total : 0;
    var isLoading = isLoadingHistory || !(epochs === null || epochs === void 0 ? void 0 : epochs.length);
    (0,react.useEffect)(function() {
        // Fetch history if they have not opened the history pane yet
        if (history.length === 0 && !isV1Claim) {
            dispatch((0,predictions/* fetchNodeHistory */.uP)({
                account: account
            }));
        }
    }, [
        account,
        history,
        dispatch,
        isV1Claim
    ]);
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(predictionsContract, "claim", [
                                    epochs
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (!(receipt === null || receipt === void 0 ? void 0 : receipt.status)) return [
                            3,
                            3
                        ];
                        if (!isV1Claim) {
                            // Immediately mark rounds as claimed
                            dispatch((0,predictions/* markAsCollected */.WB)(epochs.reduce(function(accum, epoch) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, true));
                            }, {})));
                        }
                        return [
                            4,
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess()
                        ];
                    case 2:
                        _state.sent();
                        helperToast/* helperToast.success */.U.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Winnings collected!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your prizes have been sent to your wallet")
                                })
                            ]
                        }), {
                            hideTitle: true
                        });
                        onDismiss();
                        dispatch((0,predictions/* fetchNodeHistory */.uP)({
                            account: account
                        }));
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        className: "modal-winning",
        $minWidth: "285px",
        position: "relative",
        mt: "124px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                className: "modal-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontWeight: 700,
                            color: "textMain",
                            children: t("Collect Winnings")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        color: "textMain",
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        mb: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CupWinning/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "start",
                        justifyContent: "space-between",
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: 500,
                                children: t("Collecting")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                style: {
                                    textAlign: "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontWeight: 500,
                                        children: "".concat((0,formatBalance/* formatNumber */.uf)(total, 0, 4), " FTM")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "primary",
                                        children: "$".concat(totalBnb.toFixed(2))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "start",
                        justifyContent: "center",
                        mb: "16px",
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            height: "21",
                            width: "140px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "white60",
                            fontSize: "12px",
                            children: epochs.length === 1 ? t("From round %round%", {
                                round: epochs[0]
                            }) : t("From rounds %rounds%", {
                                rounds: epochs.join(", ")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: handleClick,
                        isLoading: isPendingTx || isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 500,
                                fontSize: 14,
                                color: "#060303"
                            },
                            children: !isPendingTx ? t("Confirm") : t("Confirming...")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CollectRoundWinningsModal = (CollectRoundWinningsModal);

;// CONCATENATED MODULE: ./src/views/Predictions/components/CollectWinningsButton.tsx










var CollectWinningsButton = function(_param) {
    var hasClaimed = _param.hasClaimed, onSuccess = _param.onSuccess, price = _param.price, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "hasClaimed",
        "onSuccess",
        "price",
        "children"
    ]);
    var ref = (0,predictions_hooks/* useCollectWinningModalProps */.Dh)(), history = ref.history, isLoadingHistory = ref.isLoadingHistory;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref1.address, token = ref1.token;
    var handleClickButton = function(event) {
        event.stopPropagation();
        onPresentCollectWinningsModal();
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectRoundWinningsModal, {
        price: price,
        dispatch: dispatch,
        history: history,
        isLoadingHistory: isLoadingHistory,
        onSuccess: onSuccess,
        predictionsAddress: predictionsAddress,
        token: token
    }), false, true, "CollectRoundWinningsModal"), 1), onPresentCollectWinningsModal = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: handleClickButton,
        disabled: hasClaimed
    }, props), {
        children: children
    }));
};
/* harmony default export */ var components_CollectWinningsButton = (CollectWinningsButton);

// EXTERNAL MODULE: ./src/views/Predictions/hooks/usePollOraclePrice.ts
var usePollOraclePrice = __webpack_require__(37408);
;// CONCATENATED MODULE: ./src/views/Predictions/components/CollectWinningsPopup.tsx



function CollectWinningsPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0) scaleY(5);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"
    ]);
    CollectWinningsPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectWinningsPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  20% {\n    transform: translate3d(0, 10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0) scaleY(3);\n  }\n"
    ]);
    CollectWinningsPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  padding-left: 16px;\n  padding-right: 16px;\n  width: fit-content;\n  position: absolute;\n  z-index: 50;\n  right: 0;\n\n  &.popup-enter-active {\n    ",
        "\n  }\n\n  &.popup-enter-done {\n  }\n\n  &.popup-exit-done {\n    bottom: -2000px;\n  }\n\n  &.popup-exit-active {\n    ",
        "\n  }\n\n  ",
        " {\n    bottom: 16px;\n    justify-content: flex-end;\n\n    &.popup-enter-done {\n      bottom: 16px;\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    bottom: 16px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  /* background-color: ",
        "; */\n  border-radius: 12px;\n  color: #ffffff;\n  display: flex;\n  width: 300px;\n  padding: 24px 16px;\n  background: linear-gradient(90deg, #149274 0%, #00160e 100%);\n\n  position: relative;\n\n  .CloseIcon {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    cursor: pointer;\n\n    &:hover {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n\n    & > button {\n      margin-left: 12px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












/**
 * @see https://github.com/animate-css/animate.css/tree/main/source
 */ var bounceInKeyframe = (0,styled_components_browser_esm/* keyframes */.F4)(CollectWinningsPopup_templateObject());
var bounceOutKeyframe = (0,styled_components_browser_esm/* keyframes */.F4)(CollectWinningsPopup_templateObject1());
var bounceInAnimation = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), bounceInKeyframe);
var bounceOutAnimation = (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), bounceOutKeyframe);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4c5b56b-0"
})(_templateObject4(), bounceInAnimation, bounceOutAnimation, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Popup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4c5b56b-1"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CollectWinningsPopup = function() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,react.useRef)(null);
    var timer = (0,react.useRef)(null);
    var account = (0,src/* useWeb3React */.Ge)().account;
    var predictionStatus = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    // const dispatch = useLocalDispatch()
    var ref2 = (0,ConfigProvider/* useConfig */.ZR)(), api = ref2.api, token = ref2.token;
    var ref3 = (0,react.useState)(-100), bottom = ref3[0], setBottom = ref3[1];
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    // const handleOpenHistory = () => {
    //   dispatch(setHistoryPaneState(true))
    // }
    var handleClick = function() {
        setIsOpen(false);
        clearInterval(timer.current);
    };
    // Check user's history for unclaimed winners
    (0,react.useEffect)(function() {
        var isCancelled = false;
        if (account) {
            timer.current = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var bets, winnerBets;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,helpers/* getBetHistory */.Fr)({
                                    user: account.toLowerCase(),
                                    claimed: false
                                }, undefined, undefined, api, token.symbol)
                            ];
                        case 1:
                            bets = _state.sent();
                            if (!isCancelled) {
                                winnerBets = bets.filter(function(bet) {
                                    return bet.position === bet.round.position;
                                });
                                if (!isHistoryPaneOpen) {
                                    setIsOpen(winnerBets.length > 0);
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            }), 30000);
        }
        return function() {
            clearInterval(timer.current);
            isCancelled = true;
        };
    }, [
        account,
        timer,
        predictionStatus,
        setIsOpen,
        isHistoryPaneOpen,
        api,
        token.symbol
    ]);
    // Any time the history pane is open make sure the popup closes
    (0,react.useEffect)(function() {
        if (isHistoryPaneOpen) {
            setIsOpen(false);
        }
    }, [
        isHistoryPaneOpen,
        setIsOpen
    ]);
    var heightOfAll = document.documentElement.scrollHeight;
    (0,react.useEffect)(function() {
        var callback = function() {
            setBottom(heightOfAll - (window.scrollY + window.innerHeight) + 16) // 16px spacing
            ;
        };
        callback();
        window.addEventListener("scroll", callback);
        return function() {
            window.removeEventListener("scroll", callback);
        };
    }, [
        heightOfAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
        in: isOpen,
        unmountOnExit: true,
        nodeRef: ref1,
        timeout: 1000,
        classNames: "popup",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            ref: ref1,
            style: {
                bottom: bottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrophyGold/* default */.Z, {
                        mr: "12px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsButton, {
                        hasClaimed: false,
                        width: "200px",
                        price: price || 0,
                        children: t("Collect Winnings")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        color: "white20",
                        width: "16px",
                        onClick: handleClick,
                        className: "CloseIcon"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_CollectWinningsPopup = (/*#__PURE__*/(0,react.memo)(CollectWinningsPopup));

;// CONCATENATED MODULE: ./src/views/Predictions/components/Container.tsx

function Container_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    Container_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// import backgroundBase64 from './config'
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c0fa3c8e-0"
})(Container_templateObject());
/* harmony default export */ var components_Container = (/*#__PURE__*/(0,react.memo)(Container));

// EXTERNAL MODULE: ./src/components/DisclaimerModal/index.tsx
var DisclaimerModal = __webpack_require__(8008);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RiskDisclaimer.tsx







function RiskDisclaimer() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionAcceptedRisk */.oI)(), 2), hasAcceptedRisk = ref[0], setHasAcceptedRisk = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerModal/* default */.Z, {
        id: "predictions-risk-disclaimer",
        header: t("This Product is in beta."),
        subtitle: t("Once you enter a position, you cannot cancel or adjust it."),
        checks: [
            {
                key: "responsibility-checkbox",
                content: t("I understand that I am using this product at my own risk. Any losses incurred due to my actions are my own responsibility")
            },
            {
                key: "beta-checkbox",
                content: t("I understand that this product is still in beta. I am participating at my own risk")
            }, 
        ],
        onSuccess: function() {
            return setHasAcceptedRisk(true);
        }
    }), false, false), 2), onPresentRiskDisclaimer = ref1[0], onDismiss = ref1[1];
    (0,react.useEffect)(function() {
        if (!hasAcceptedRisk) {
            onPresentRiskDisclaimer();
        }
        return function() {
            onDismiss();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasAcceptedRisk
    ]);
    return null;
}
/* harmony default export */ var components_RiskDisclaimer = (/*#__PURE__*/(0,react.memo)(RiskDisclaimer));

// EXTERNAL MODULE: ./src/views/Predictions/context/SwiperProvider.tsx
var SwiperProvider = __webpack_require__(69241);
// EXTERNAL MODULE: ./node_modules/split-grid/dist/split-grid.mjs
var split_grid = __webpack_require__(26741);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PowerByChainLink.tsx
var PowerByChainLink = __webpack_require__(8299);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(78593);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/delay.js
var delay = __webpack_require__(98066);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/components/Chart/ChartbyLabel.tsx






var ChartbyLabel_ChartByLabel = function(_param) {
    var symbol = _param.symbol, link = _param.link, by = _param.by, linkProps = _param.linkProps, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "symbol",
        "link",
        "by",
        "linkProps"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        px: "24px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "14px",
                mr: "4px",
                children: [
                    symbol,
                    " ",
                    t("Chart"),
                    " ",
                    t("by")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                fontSize: "14px",
                href: link,
                external: true
            }, linkProps), {
                children: by
            }))
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/TabToggle/index.tsx
var TabToggle = __webpack_require__(54757);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/TradingView.tsx











/**
 * When the script tag is injected the TradingView object is not immediately
 * available on the window. So we listen for when it gets set
 */ var tradingViewListener = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return Object.defineProperty(window, "TradingView", {
                        configurable: true,
                        set: function set(value) {
                            this.tv = value;
                            resolve(value);
                        }
                    });
                })
            ];
        });
    });
    return function tradingViewListener() {
        return _ref.apply(this, arguments);
    };
}();
var initializeTradingView = function(TradingViewObj, theme, localeCode, opts) {
    var timezone = "Etc/UTC";
    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
    // noop
    }
    /* eslint-disable new-cap */ /* eslint-disable no-new */ // @ts-ignore
    return new TradingViewObj.widget((0,src_object_spread/* default */.Z)({
        // Advanced Chart Widget uses the legacy embedding scheme,
        // an id property should be specified in the settings object
        id: opts.container_id,
        autosize: true,
        height: "100%",
        symbol: "BINANCE:BNBBUSD",
        interval: "5",
        timezone: timezone,
        theme: theme.isDark ? "dark" : "dark",
        style: "1",
        locale: localeCode,
        toolbar_bg: "#f1f3f6",
        enable_publishing: false,
        allow_symbol_change: true,
        hide_side_toolbar: false,
        enabled_features: [
            "header_fullscreen_button"
        ]
    }, opts));
};
var TradingView = function(param) {
    var id = param.id, symbol = param.symbol;
    var currentLanguage = (0,localization_src/* useTranslation */.$G)().currentLanguage;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,react.useEffect)(function() {
        var opts = {
            container_id: id,
            symbol: symbol
        };
        if (isMobile) {
            opts.hide_side_toolbar = true;
        }
        // @ts-ignore
        if (window.tv) {
            // @ts-ignore
            initializeTradingView(window.tv, theme, currentLanguage.code, opts);
        } else {
            tradingViewListener().then(function(tv) {
                initializeTradingView(tv, theme, currentLanguage.code, opts);
            });
        }
    // Ignore isMobile to avoid re-render TV
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        theme,
        currentLanguage,
        id,
        symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        overflow: "hidden",
        className: "tradingview_container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://s3.tradingview.com/tv.js",
                strategy: "lazyOnload",
                id: "tv.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: id
            })
        ]
    });
};
function useTradingViewEvent(param) {
    var id = param.id, onNoDataEvent = param.onNoDataEvent, onLoadedEvent = param.onLoadedEvent;
    useEffect(function() {
        var onNoDataAvailable = function(event) {
            var payload = event.data;
            if (payload.name === "tv-widget-no-data") {
                if (id && payload.frameElementId === id) {
                    onNoDataEvent === null || onNoDataEvent === void 0 ? void 0 : onNoDataEvent();
                }
            }
            if (payload.name === "tv-widget-load") {
                if (id && payload.frameElementId === id) {
                    onLoadedEvent === null || onLoadedEvent === void 0 ? void 0 : onLoadedEvent();
                }
            }
        };
        window.addEventListener("message", onNoDataAvailable);
        // eslint-disable-next-line consistent-return
        return function() {
            window.removeEventListener("message", onNoDataAvailable);
        };
    }, [
        id,
        onNoDataEvent,
        onLoadedEvent
    ]);
}
// Required to link to TradingView website for the widget
var TradingViewLabel = function(_param) {
    var symbol = _param.symbol, props = _object_without_properties(_param, [
        "symbol"
    ]);
    return /*#__PURE__*/ _jsx(ChartByLabel, _object_spread({
        link: "https://www.tradingview.com/symbols/".concat(symbol),
        symbol: symbol,
        by: "TradingView"
    }, props));
};
/* harmony default export */ var components_TradingView = (TradingView);

;// CONCATENATED MODULE: ./src/views/Predictions/components/TradingView.tsx



var TRADING_VIEW_COMPONENT_ID = "tradingview_b239c";
var TOKEN = "FTM";
var TradingView_TradingView = function() {
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TradingView, {
        id: TRADING_VIEW_COMPONENT_ID,
        symbol: "BINANCE:".concat(TOKEN, "USD")
    });
};
/* harmony default export */ var Predictions_components_TradingView = (TradingView_TradingView);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/Notification.tsx

function Notification_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute !important;\n  top: 50%;\n  transform: translateY(-70%);\n  align-items: center;\n  display: flex;\n  flex: 1;\n  height: 100%;\n  justify-content: center;\n\n  .title-pause {\n    cursor: pointer;\n\n    display: flex;\n    align-items: center;\n\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 140%; /* 22.4px */\n\n    color: #ffffff;\n\n    svg {\n      margin-right: 8px;\n    }\n  }\n\n  .content-pause {\n    background: #232121;\n    overflow: unset;\n    height: unset;\n\n    button {\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 140%; /* 19.6px */\n    }\n  }\n\n  &.noti-pause {\n    position: relative;\n\n    h2 {\n      display: none;\n    }\n  }\n\n  .img-pause {\n    position: absolute;\n\n    top: -45px;\n    right: 0;\n  }\n\n  .card-wrapper {\n    width: 381px;\n  }\n"
    ]);
    Notification_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Notification_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 320px;\n"
    ]);
    Notification_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Notification_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 12px;\n  text-align: center;\n  width: 100%;\n  z-index: 5;\n  cursor: pointer;\n"
    ]);
    Notification_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Notification_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 120px;\n  width: 40%;\n"
    ]);
    Notification_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Notification_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bb39fd0-0"
})(Notification_templateObject());
var CardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bb39fd0-1"
})(Notification_templateObject1());
var Notification_BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bb39fd0-2"
})(Notification_templateObject2());
var BackButtonStyle = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-5bb39fd0-3"
})(Notification_templateObject3());
var BackButton = function() {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsxs(BackButtonStyle, {
        variant: "primary",
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(ArrowBackIcon, {
                color: "white",
                mr: "8px"
            }),
            t("Back")
        ]
    });
};
var Notification = function(param) {
    var title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_Wrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
            className: "card-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                className: "content-pause",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            mb: "24px",
                            children: title
                        }),
                        children
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Notification_Notification = (Notification);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/ErrorNotification.tsx






var ErrorNotification = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var handleOpenHistory = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notification_Notification, {
        title: t("Error"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                mb: "24px",
                children: t("This page can’t be displayed right now due to an error. Please check back soon.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "primary",
                width: "100%",
                onClick: handleOpenHistory,
                children: t("Show History")
            })
        ]
    });
};
/* harmony default export */ var Notification_ErrorNotification = (ErrorNotification);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/PauseNotification.tsx








var PauseNotification = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var handleOpenHistory = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    var router = (0,next_router.useRouter)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notification_Notification, {
        className: "noti-pause",
        title: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "32px",
                children: t("Markets Paused")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: "12px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("Prediction markets have been paused due to an error.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("All open positions have been cancelled.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        children: t("You can reclaim any funds entered into existing positions via the History tab on this page.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "primary",
                width: "100%",
                onClick: handleOpenHistory,
                children: t("Show History")
            })
        ]
    });
};
/* harmony default export */ var Notification_PauseNotification = (PauseNotification);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Notification/index.tsx




// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(44417);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Wait.tsx
var Wait = __webpack_require__(13522);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PlayCircleOutline.tsx
var PlayCircleOutline = __webpack_require__(95703);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(95459);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(1274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
;// CONCATENATED MODULE: ./src/views/Predictions/components/ReclaimPositionButton.tsx














var ReclaimPositionButton = function(_param) {
    var epoch = _param.epoch, onSuccess = _param.onSuccess, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "epoch",
        "onSuccess",
        "children"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref.address;
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, isPendingTx = ref1.loading;
    var handleReclaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(predictionsContract, "claim", [
                                    [
                                        epoch
                                    ]
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (!(receipt === null || receipt === void 0 ? void 0 : receipt.status)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess()
                        ];
                    case 2:
                        _state.sent();
                        helperToast/* helperToast.success */.U.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Position reclaimed!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                    txHash: receipt.transactionHash
                                })
                            ]
                        }), {
                            hideTitle: true
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReclaim() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        mb: "16px",
        variant: "primary",
        onClick: handleReclaim,
        isLoading: isPendingTx
    }, props), {
        children: !isPendingTx ? children || t("Reclaim Position") : t("Reclaiming...")
    }));
};
/* harmony default export */ var components_ReclaimPositionButton = (ReclaimPositionButton);

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/views/Predictions/helpers.ts
var Predictions_helpers = __webpack_require__(62682);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(40696);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(45203);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
;// CONCATENATED MODULE: ./src/views/Predictions/components/PositionTag.tsx




function PositionTag_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n"
    ]);
    PositionTag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledTag = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3a93c5b5-0"
})(PositionTag_templateObject());
var Tag = function(_param) {
    var _bg = _param.bg, bg = _bg === void 0 ? "success" : _bg, startIcon = _param.startIcon, textColor = _param.textColor, children = _param.children, onClick = _param.onClick, hiddenArrow = _param.hiddenArrow, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "bg",
        "startIcon",
        "textColor",
        "children",
        "onClick",
        "hiddenArrow"
    ]);
    var icon = startIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
        color: "black"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTag, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        bg: bg,
        py: "4px",
        px: "8px",
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : "normal"
        }
    }, props), {
        children: [
            !hiddenArrow && icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontWeight: 700,
                textTransform: "uppercase",
                color: textColor,
                ml: "4px",
                children: children
            })
        ]
    }));
};
var PositionTag = function(_param) {
    var betPosition = _param.betPosition, children = _param.children, hiddenArrow = _param.hiddenArrow, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "betPosition",
        "children",
        "hiddenArrow"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isUpPosition = betPosition === types/* BetPosition.BULL */.Tu.BULL;
    var icon = isUpPosition ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
        height: "16px",
        color: "black"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
        height: "16px",
        color: "white"
    });
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "4px",
                children: t("Neither position wins this round.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The locked and closed prices are identical (within 8 decimal places), so ALL funds invested in both positions go to the Treasury.")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    if (betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tooltipVisible && tooltip,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                    ref: targetRef,
                    color: "secondary",
                    fontWeight: "300",
                    textTransform: "uppercase",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: "#ffffff"
                                },
                                children: t("To Treasury")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                width: "16px",
                                ml: "4px",
                                color: "white"
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        bg: isUpPosition ? "success" : "failure",
        startIcon: !hiddenArrow && icon,
        hiddenArrow: hiddenArrow
    }, props), {
        textColor: isUpPosition ? "black" : "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            fontSize: "14px",
            color: isUpPosition ? "black" : "white",
            fontWeight: 700,
            children: children
        })
    }));
};
/* harmony default export */ var components_PositionTag = (PositionTag);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/styles.tsx




function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 24px;\n  padding: 1px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  background: ",
        ";\n  border-radius: 24px;\n  padding: 24px;\n  height: 188px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var getPrizePoolAmount = function(totalAmount, displayedDecimals) {
    if (!totalAmount) {
        return "0";
    }
    return (0,Predictions_helpers/* formatBnbv2 */.rc)(totalAmount, displayedDecimals);
};
var Row = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "space-between"
    }, props), {
        children: children
    }));
};
var PrizePoolRow = function(_param) {
    var totalAmount = _param.totalAmount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "totalAmount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontWeight: 700,
                children: [
                    t("Prize Pool"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontWeight: 700,
                children: "".concat(getPrizePoolAmount(totalAmount, 2), " FTM")
            })
        ]
    }));
};
var PayoutRow = function(_param) {
    var positionLabel = _param.positionLabel, multiplier = _param.multiplier, amount = _param.amount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "positionLabel",
        "multiplier",
        "amount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var formattedMultiplier = "".concat(multiplier.toLocaleString(undefined, {
        maximumFractionDigits: 2
    }), "x");
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: "18px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "white60",
                textTransform: "uppercase",
                children: positionLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        fontWeight: 700,
                        children: t("%multiplier% Payout", {
                            multiplier: formattedMultiplier
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mx: "4px",
                        children: "|"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        fontWeight: 700,
                        children: "".concat(formatBnb(amount, 2), " FTM")
                    })
                ]
            })
        ]
    }));
};
var LockPriceRow = function(_param) {
    var lockPrice = _param.lockPrice, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockPrice"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), displayedDecimals = ref.displayedDecimals, minPriceUsdDisplayed = ref.minPriceUsdDisplayed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "14px",
                children: [
                    t("Locked Price"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(lockPrice, minPriceUsdDisplayed, displayedDecimals)
            })
        ]
    }));
};
var getBackgroundColor = function(param) {
    var theme = param.theme, betPosition = param.betPosition, isNext = param.isNext, isLive = param.isLive, hasEntered = param.hasEntered;
    if (isNext) {
        return "linear-gradient(196.44deg, #31FFA8, #FF00F5, #3DFF44)";
    }
    if (isLive) {
        return "#FF4D4F";
    }
    if (hasEntered) {
        return theme.colors.secondary;
    }
    switch(betPosition){
        case types/* BetPosition.BULL */.Tu.BULL:
            return theme.colors.success;
        case types/* BetPosition.BEAR */.Tu.BEAR:
            return theme.colors.failure;
        case types/* BetPosition.HOUSE */.Tu.HOUSE:
            return theme.colors.textDisabled;
        default:
            return "#FFFFFF1A";
    }
};
var Background = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-b8ce89b9-0"
})(styles_templateObject(), getBackgroundColor);
var StyledRoundResultBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8ce89b9-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var RoundResultBox = function(_param) {
    var _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, _hasEntered = _param.hasEntered, hasEntered = _hasEntered === void 0 ? false : _hasEntered, _isLive = _param.isLive, isLive = _isLive === void 0 ? false : _isLive, children = _param.children, style = _param.style, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isNext",
        "hasEntered",
        "isLive",
        "children",
        "style"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        isNext: isNext,
        hasEntered: hasEntered,
        isLive: isLive
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRoundResultBox, {
            style: style,
            children: children
        })
    }));
};
var RoundPrice = function(param) {
    var lockPrice = param.lockPrice, closePrice = param.closePrice;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), displayedDecimals = ref.displayedDecimals, minPriceUsdDisplayed = ref.minPriceUsdDisplayed;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var priceDifference = (0,Predictions_helpers/* getPriceDifference */.kJ)(closePrice, lockPrice);
    var textColor = (0,react.useMemo)(function() {
        switch(betPosition){
            case types/* BetPosition.BULL */.Tu.BULL:
                return "success";
            case types/* BetPosition.BEAR */.Tu.BEAR:
                return "failure";
            case types/* BetPosition.HOUSE */.Tu.HOUSE:
            default:
                return "textDisabled";
        }
    }, [
        betPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        mb: "16px",
        height: "36px",
        children: [
            closePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: textColor,
                fontWeight: 700,
                fontSize: "20px",
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(closePrice, minPriceUsdDisplayed, displayedDecimals)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                height: "34px",
                my: "1px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                betPosition: betPosition,
                height: "100%",
                children: (0,Predictions_helpers/* formatUsdv2 */.pf)(priceDifference.abs(), minPriceUsdDisplayed, displayedDecimals)
            })
        ]
    });
};
var getPrizePoolAmountHistory = function(totalAmount, displayedDecimals) {
    if (!totalAmount) {
        return "0";
    }
    return formatBnb(totalAmount, displayedDecimals);
};
var PrizePoolHistoryRow = function(_param) {
    var totalAmount = _param.totalAmount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "totalAmount"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "white60",
                children: t("Prize Pool")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontWeight: 700,
                style: {
                    color: "#03F5AE"
                },
                children: "".concat(getPrizePoolAmountHistory(totalAmount, 2), " FTM")
            })
        ]
    }));
};
var LockPriceHistoryRow = function(_param) {
    var lockPrice = _param.lockPrice, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockPrice"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "white60",
                children: t("Locked Price")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontWeight: 700,
                children: formatUsd(lockPrice, displayedDecimals)
            })
        ]
    }));
} /**
 * END TEMPORARY COMPONENTS
 */ ;

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/RoundResult.tsx








var RoundResult = function(_param) {
    var round = _param.round, _hasFailed = _param.hasFailed, hasFailed = _hasFailed === void 0 ? false : _hasFailed, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "round",
        "hasFailed",
        "children"
    ]);
    var lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultBox, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        betPosition: betPosition
    }, props), {
        style: {
            height: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "white",
                fontSize: "14px",
                mb: "8px",
                children: t("Closed Price")
            }),
            hasFailed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                textTransform: "uppercase",
                color: "textDisabled",
                mb: "16px",
                fontSize: "14px",
                children: t("Cancelled")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundPrice, {
                lockPrice: lockPrice,
                closePrice: closePrice
            }),
            lockPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceRow, {
                lockPrice: lockPrice,
                mb: "16px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                totalAmount: totalAmount
            }),
            children
        ]
    }));
};
/* harmony default export */ var RoundResult_RoundResult = (RoundResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/RoundResultHistory.tsx




function RoundResultHistory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1px;\n  border-radius: 12px !important;\n\n  > div {\n    padding: 12px 16px;\n    border-radius: 11px;\n  }\n"
    ]);
    RoundResultHistory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledRoundHistoryBox = (0,styled_components_browser_esm/* default */.ZP)(RoundResultBox).withConfig({
    componentId: "sc-3d9ea70f-0"
})(RoundResultHistory_templateObject());
var RoundResultHistory_RoundResult = function(_param) {
    var round = _param.round, children = _param.children, isOpenRound = _param.isOpenRound, isLiveRound = _param.isLiveRound, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "round",
        "children",
        "isOpenRound",
        "isLiveRound"
    ]);
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    var lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount;
    // console.log('totalAmount', totalAmount)
    var betPosition = closePrice > lockPrice ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR;
    var isPositionUp = betPosition === types/* BetPosition.BULL */.Tu.BULL;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var priceDifference = closePrice - lockPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoundHistoryBox, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        betPosition: betPosition
    }, props), {
        style: {
            height: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "text",
                fontSize: "14px",
                fontWeight: 700,
                textTransform: "uppercase",
                mb: "16px",
                children: t("Closed Price")
            }),
            round.failed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                textTransform: "uppercase",
                color: "textDisabled",
                mb: "16px",
                fontSize: "14px",
                style: {
                    fontWeight: 700
                },
                children: t("Cancelled")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: isPositionUp ? "success" : "failure",
                        fontWeight: 700,
                        fontSize: "20px",
                        children: isOpenRound || isLiveRound ? "$--" : formatUsd(Math.abs(closePrice), displayedDecimals)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                        hiddenArrow: isOpenRound || isLiveRound,
                        style: {
                            height: "37px"
                        },
                        betPosition: betPosition,
                        children: isOpenRound || isLiveRound ? "$--" : formatUsd(Math.abs(priceDifference), displayedDecimals)
                    })
                ]
            }),
            lockPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceHistoryRow, {
                lockPrice: lockPrice,
                style: {
                    marginBottom: "16px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolHistoryRow, {
                totalAmount: totalAmount,
                style: {
                    marginBottom: "16px"
                }
            }),
            children
        ]
    }));
};
/* harmony default export */ var RoundResultHistory = (RoundResultHistory_RoundResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundResult/index.tsx




// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Prize.tsx
var Prize = __webpack_require__(98468);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Block.tsx
var Block = __webpack_require__(31246);
// EXTERNAL MODULE: ./node_modules/web3/dist/web3.min.js
var web3_min = __webpack_require__(37918);
var web3_min_default = /*#__PURE__*/__webpack_require__.n(web3_min);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 25 modules
var contractHelpers = __webpack_require__(21421);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useIsRefundable.ts






var useIsRefundable = function(epoch) {
    var ref = (0,react.useState)(false), isRefundable = ref[0], setIsRefundable = ref[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var address = (0,ConfigProvider/* useConfig */.ZR)().address;
    (0,react.useEffect)(function() {
        var fetchRefundableStatus = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var predictionsContract, refundable, ledger;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!account) return [
                                3,
                                4
                            ];
                            predictionsContract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                            return [
                                4,
                                predictionsContract.refundable(epoch, account)
                            ];
                        case 1:
                            refundable = _state.sent();
                            if (!refundable) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                predictionsContract.ledger(epoch, account)
                            ];
                        case 2:
                            ledger = _state.sent();
                            setIsRefundable(ledger.claimed === false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsRefundable(false);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchRefundableStatus() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchRefundableStatus();
        var clear = setInterval(fetchRefundableStatus, 5000);
        return function() {
            return clearInterval(clear);
        };
    }, [
        account,
        epoch,
        setIsRefundable,
        address
    ]);
    return {
        isRefundable: isRefundable,
        setIsRefundable: setIsRefundable
    };
};
/* harmony default export */ var hooks_useIsRefundable = (useIsRefundable);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/BetResult.tsx




function BetResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px !important;\n  background: ",
        ";\n  height: 37px !important;\n  color: black;\n  font-size: 14px;\n  font-weight: 700;\n"
    ]);
    BetResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BetResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n"
    ]);
    BetResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BetResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  margin: 8px 0 16px;\n"
    ]);
    BetResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





















var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(components_CollectWinningsButton).withConfig({
    componentId: "sc-412f0686-0"
})(BetResult_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
var StyledBetResult = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-412f0686-1"
})(BetResult_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-412f0686-2"
})(BetResult_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var BetResult = function(param) {
    var bet = param.bet, result = param.result;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var treasuryFee = (0,predictions_hooks/* useGetPredictionsTreasuryFee */.We)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var isRefundable = hooks_useIsRefundable(bet.round.epoch).isRefundable;
    var canClaim = (0,predictions_hooks/* useGetIsClaimable */.Wx)(bet.round.epoch);
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var bnbBusdPrice = Number(web3_min_default().utils.fromWei(price.toString())) * 10e9;
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        as: "p",
        children: t("Includes your original position and your winnings, minus the %fee% fee.", {
            fee: "".concat(treasuryFee / 100, "%")
        })
    }), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var isWinner = result === helpers/* Result.WIN */.x4.WIN;
    // Winners get the payout, otherwise the claim what they put it if it was canceled
    var payout = isWinner ? getNetPayout(bet, config/* REWARD_RATE */.Ck) : bet.amount;
    var totalPayout = bnbBusdPrice * payout;
    // const totalPayout = payout * (tokenInfo?.[0]?.OPX?.price || 0)
    var returned = payout + bet.amount;
    var isLoss = !isWinner || isWinner && payout < 0;
    var headerColor = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return "warning";
            case helpers/* Result.LOSE */.x4.LOSE:
                return "white60";
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return "white60";
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return "white60";
            default:
                return "text";
        }
    }, [
        result
    ]);
    var headerText = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return t("Win");
            case helpers/* Result.LOSE */.x4.LOSE:
                return t("Lose");
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return t("Cancelled");
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#ffffff"
                    },
                    children: t("To Treasury")
                });
            default:
                return "";
        }
    }, [
        t,
        result
    ]);
    var headerIcon = (0,react.useMemo)(function() {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Prize/* default */.Z, {
                    color: headerColor
                });
            case helpers/* Result.LOSE */.x4.LOSE:
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                    color: headerColor
                });
            default:
                return null;
        }
    }, [
        result,
        headerColor
    ]);
    var resultColor = (0,react.useMemo)(function() {
        if (result === helpers/* Result.CANCELED */.x4.CANCELED || result === helpers/* Result.HOUSE */.x4.HOUSE) {
            return "text";
        }
        if (isLoss) return "failure";
        return "success";
    }, [
        isLoss,
        result
    ]);
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // We have to mark the bet as claimed immediately because it does not update fast enough
                dispatch((0,predictions/* markAsCollected */.WB)((0,_define_property/* default */.Z)({}, bet.round.epoch, true)));
                dispatch((0,predictions/* fetchLedgerData */.Ub)({
                    account: account,
                    epochs: [
                        bet.round.epoch
                    ]
                }));
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: 700,
                        lineHeight: "140%",
                        children: t("Your History")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: "h3",
                                color: headerColor,
                                textTransform: "uppercase",
                                fontWeight: 700,
                                mr: "4px",
                                children: headerText
                            }),
                            headerIcon
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetResult, {
                children: [
                    result === helpers/* Result.WIN */.x4.WIN && canClaim && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        hasClaimed: !canClaim,
                        width: "100%",
                        mb: "16px",
                        onSuccess: handleSuccess,
                        price: price || 0,
                        children: bet.claimed ? t("Already Collected") : t("Collect Winnings")
                    }),
                    bet.claimed && bet.claimedHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                            href: (0,utils/* getBlockExploreLink */.C)(bet.claimedHash, "transaction"),
                            mb: "16px",
                            children: t("View on BscScan")
                        })
                    }),
                    result === helpers/* Result.CANCELED */.x4.CANCELED && isRefundable && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                        epoch: bet.round.epoch,
                        width: "100%",
                        mb: "16px",
                        style: {
                            background: "#03F5AE",
                            color: "#060303",
                            height: "37px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "white60",
                                children: t("Your direction")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                                betPosition: bet.position,
                                style: {
                                    height: "37px"
                                },
                                children: bet.position === types/* BetPosition.BULL */.Tu.BULL ? t("Up") : t("Down")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "white60",
                                children: t("Your position")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: 700,
                                children: "".concat(formatBnb(bet.amount, 2), " FTM")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "start",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "white60",
                                children: isWinner ? t("Your PnL") : t("Your result")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                style: {
                                    textAlign: "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontWeight: 700,
                                        color: resultColor,
                                        children: "".concat(isLoss ? "-" : "+").concat(formatBnb(Math.abs(payout), 2), " FTM")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "white60",
                                        children: "$".concat(Math.abs(totalPayout).toFixed(2))
                                    })
                                ]
                            })
                        ]
                    }),
                    isWinner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "start",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "white60",
                                        children: t("Amount to collect")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                color: "white",
                                                children: "".concat(formatBnb(returned, 2), " FTM")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ref: targetRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                    color: "white",
                                                    ml: "4px"
                                                })
                                            })
                                        ]
                                    }),
                                    tooltipVisible && tooltip
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_BetResult = (BetResult);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/BetDetails.tsx

function BetDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 27px 24px;\n  background-color: #11121b;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px;\n"
    ]);
    BetDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledBetDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b81c89c-0"
})(BetDetails_templateObject());
var BetDetails = function(param) {
    var bet = param.bet, result = param.result, isOpenRound = param.isOpenRound, isLiveRound = param.isLiveRound;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var _round = bet.round, totalAmount = _round.totalAmount, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount;
    var bullMultiplier = getMultiplier(totalAmount, bullAmount);
    var bearMultiplier = getMultiplier(totalAmount, bearAmount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetDetails, {
        children: [
            result === helpers/* Result.CANCELED */.x4.CANCELED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                color: "failure",
                mb: "24px",
                children: t("This round was automatically cancelled due to an error. If you entered a position, please reclaim your funds below.")
            }),
            result !== helpers/* Result.LIVE */.x4.LIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)(History_BetResult, {
                bet: bet,
                result: result
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontWeight: 700,
                mb: "8px",
                children: t("Round History")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultHistory, {
                round: bet.round,
                isOpenRound: isOpenRound,
                isLiveRound: isLiveRound,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutRow, {
                        positionLabel: t("Up"),
                        multiplier: bullMultiplier,
                        amount: bullAmount,
                        style: {
                            marginBottom: "16px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutRow, {
                        positionLabel: t("Down"),
                        multiplier: bearMultiplier,
                        amount: bearAmount
                    })
                ]
            }),
            bet.round.lockBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Opening Block")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,utils/* getBlockExploreLink */.C)(bet.round.lockBlock, "block"),
                        external: true,
                        children: bet.round.lockBlock
                    })
                ]
            }),
            bet.round.closeBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Closing Block")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,utils/* getBlockExploreLink */.C)(bet.round.closeBlock, "block"),
                        external: true,
                        children: bet.round.closeBlock
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_BetDetails = (BetDetails);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/HistoricalBet.tsx




function HistoricalBet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n\n  &:first-child {\n    padding-top: 0;\n  }\n"
    ]);
    HistoricalBet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HistoricalBet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    HistoricalBet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HistoricalBet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  width: 16px;\n  height: 16px;\n"
    ]);
    HistoricalBet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var StyledBet = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    alignItems: "center",
    p: "24px"
}).withConfig({
    componentId: "sc-9c2410ea-0"
})(HistoricalBet_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
});
var YourResult = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-9c2410ea-1"
})(HistoricalBet_templateObject1());
var CustomIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-9c2410ea-2"
})(HistoricalBet_templateObject2());
var HistoricalBet = function(param) {
    var bet = param.bet;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var amount = bet.amount, round = bet.round;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Neither position wins this round.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The locked and closed prices are identical (within 8 decimal places), so ALL funds invested in both positions go to the Treasury.")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var canClaim = (0,predictions_hooks/* useGetIsClaimable */.Wx)(bet.round.epoch);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var displayedDecimals = (0,ConfigProvider/* useConfig */.ZR)().displayedDecimals;
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var toggleOpen = function() {
        return setIsOpen(!isOpen);
    };
    var getRoundColor = function(result) {
        switch(result){
            case helpers/* Result.WIN */.x4.WIN:
                return "success";
            case helpers/* Result.LOSE */.x4.LOSE:
                return "failure";
            case helpers/* Result.CANCELED */.x4.CANCELED:
                return "textDisabled";
            case helpers/* Result.HOUSE */.x4.HOUSE:
                return "textDisabled";
            default:
                return "text";
        }
    };
    var getRoundPrefix = function(result) {
        if (result === helpers/* Result.LOSE */.x4.LOSE) {
            return "-";
        }
        if (result === helpers/* Result.WIN */.x4.WIN) {
            return "+";
        }
        return "";
    };
    var roundResult = (0,helpers/* getRoundResult */.yz)(bet, currentEpoch);
    // const resultTextColor = getRoundColor(roundResult)
    var resultTextPrefix = getRoundPrefix(roundResult);
    var isOpenRound = round.epoch === currentEpoch;
    var isLiveRound = status === types/* PredictionStatus.LIVE */.Gw.LIVE && round.epoch === currentEpoch - 1;
    var isWinner = roundResult === helpers/* Result.WIN */.x4.WIN;
    // Winners get the payout, otherwise the claim what they put it if it was canceled
    var payout = isWinner ? getNetPayout(bet, config/* REWARD_RATE */.Ck) : amount;
    var isLoss = !isWinner || isWinner && payout < 0;
    var resultColor = (0,react.useMemo)(function() {
        if (roundResult === helpers/* Result.CANCELED */.x4.CANCELED || roundResult === helpers/* Result.HOUSE */.x4.HOUSE) {
            return "text";
        }
        if (isLoss) return "failure";
        return "success";
    }, [
        isLoss,
        roundResult
    ]);
    var renderBetLabel = function() {
        if (isOpenRound) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                        color: "primary",
                        mr: "6px",
                        width: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "primary",
                        bold: true,
                        children: t("Starting Soon")
                    })
                ]
            });
        }
        if (isLiveRound) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {
                        color: "primary",
                        mr: "6px",
                        width: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "primary",
                        bold: true,
                        children: t("Live Now")
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: "white60",
                    children: t("Your result")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    mt: "4px",
                    fontWeight: 700,
                    color: resultColor,
                    children: roundResult === helpers/* Result.CANCELED */.x4.CANCELED ? t("Cancelled") : roundResult === helpers/* Result.HOUSE */.x4.HOUSE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            tooltipVisible && tooltip,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                ref: targetRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#ffffff"
                                        },
                                        children: t("To Treasury")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        width: "16px",
                                        ml: "4px",
                                        color: "white"
                                    })
                                ]
                            })
                        ]
                    }) : "".concat(isLoss ? "-" : "+").concat(formatBnb(Math.abs(payout), 2), " FTM")
                })
            ]
        });
    };
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // We have to mark the bet as claimed immediately because it does not update fast enough
                dispatch((0,predictions/* markAsCollected */.WB)((0,_define_property/* default */.Z)({}, bet.round.epoch, true)));
                dispatch((0,predictions/* fetchLedgerData */.Ub)({
                    account: account,
                    epochs: [
                        bet.round.epoch
                    ]
                }));
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBet, {
                onClick: toggleOpen,
                role: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "48px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "white60",
                                    children: t("Round")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    mt: "4px",
                                    fontWeight: 700,
                                    color: "#ffffff",
                                    children: [
                                        "#",
                                        round.epoch.toLocaleString()
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YourResult, {
                        px: "24px",
                        children: renderBetLabel()
                    }),
                    roundResult === helpers/* Result.WIN */.x4.WIN && canClaim && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsButton, {
                        hasClaimed: !canClaim,
                        onSuccess: handleSuccess,
                        scale: "sm",
                        mr: "8px",
                        price: price || 0,
                        height: "40px",
                        children: t("Collect")
                    }),
                    roundResult === helpers/* Result.CANCELED */.x4.CANCELED && canClaim && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                        epoch: bet.round.epoch,
                        scale: "sm",
                        mr: "8px",
                        children: t("Reclaim")
                    }),
                    !isOpenRound && !isLiveRound && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIconButton, {
                        variant: "text",
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(History_BetDetails, {
                bet: bet,
                result: (0,helpers/* getRoundResult */.yz)(bet, currentEpoch),
                isOpenRound: isOpenRound,
                isLiveRound: isLiveRound
            })
        ]
    });
};
/* harmony default export */ var History_HistoricalBet = (HistoricalBet);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(18029);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(12587);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(51983);
// EXTERNAL MODULE: ./packages/uikit/src/components/Radio/Radio.tsx + 1 modules
var Radio = __webpack_require__(42289);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/Header.tsx



function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  margin-right: 16px;\n\n  .radio-history {\n    width: 16px;\n    height: 16px;\n\n    background-color: #dbd6d6;\n\n    &:checked {\n      /* width: 7px;\n      height: 7px;\n\n      top: 5.2px;\n      left: 4.5px;\n*/\n      background-color: #ffffff;\n      border: 4px solid ",
        ";\n    }\n  }\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  padding: 72px 24px 24px;\n\n  .Back-btn {\n    color: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  @media screen and (max-width: 991px) {\n    padding-top: 24px;\n  }\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* margin-bottom: 16px; */\n  width: 100%;\n\n  & > div {\n    width: 100%;\n  }\n\n  & button {\n    width: 100%;\n    border-radius: 12px;\n  }\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 700;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var Filter = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-6cc62cb-0"
})(Header_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-6cc62cb-1"
})(Header_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ButtonMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cc62cb-2"
})(Header_templateObject2());
var CloseHistoryButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-6cc62cb-3"
})(Header_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var HistoryTabs;
(function(HistoryTabs) {
    HistoryTabs[HistoryTabs["ROUNDS"] = 0] = "ROUNDS";
    HistoryTabs[HistoryTabs["PNL"] = 1] = "PNL";
})(HistoryTabs || (HistoryTabs = {}));
var Header = function(param) {
    var activeTab = param.activeTab, setActiveTab = param.setActiveTab;
    var historyFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
    };
    var handleChange = function(newFilter) {
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (newFilter !== historyFilter) {
                    dispatch((0,predictions/* setHistoryFilter */.Yq)(newFilter));
                }
                return [
                    2
                ];
            });
        });
    };
    var switchTab = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tabIndex) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setActiveTab(tabIndex);
                        return [
                            4,
                            handleChange(types/* HistoryFilter.ALL */.dZ.ALL)()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function switchTab(tabIndex) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "140%",
                        children: t("History")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                        className: "Back-btn",
                        onClick: handleClick,
                        style: {
                            cursor: "pointer"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                    activeIndex: activeTab,
                    scale: "sm",
                    variant: "tertiary",
                    onItemClick: switchTab,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            children: t("Rounds")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            children: t("PNL")
                        })
                    ]
                })
            }),
            activeTab === HistoryTabs.ROUNDS && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "white60",
                        mt: "20px",
                        mb: "8px",
                        children: t("Filter")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        className: "radio-history",
                                        scale: "sm",
                                        checked: historyFilter === types/* HistoryFilter.ALL */.dZ.ALL,
                                        disabled: isFetchingHistory || !account,
                                        onChange: handleChange(types/* HistoryFilter.ALL */.dZ.ALL)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: "8px",
                                        children: t("All")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        className: "radio-history",
                                        scale: "sm",
                                        checked: historyFilter === types/* HistoryFilter.COLLECTED */.dZ.COLLECTED,
                                        disabled: isFetchingHistory || !account,
                                        onChange: handleChange(types/* HistoryFilter.COLLECTED */.dZ.COLLECTED)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: "8px",
                                        children: t("Collected")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        className: "radio-history",
                                        scale: "sm",
                                        checked: historyFilter === types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED,
                                        disabled: isFetchingHistory || !account,
                                        onChange: handleChange(types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: "8px",
                                        children: t("Uncollected")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var History_Header = (Header);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/index.tsx



// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 162 modules
var collapse = __webpack_require__(63705);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(37303);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(69117);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(40370);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/helpers.ts



function helpers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getV1BetHistory($skip: Int!, $where: Bet_filter) {\n        bets(first: 1000, skip: $skip, where: $where, orderBy: createdAt, orderDirection: desc) {\n          hash\n          amount\n          position\n          claimed\n          claimedAmount\n          claimedHash\n          round {\n            epoch\n            bullAmount\n            bearAmount\n            position\n            failed\n            totalAmount\n            lockPrice\n            closePrice\n            totalBets\n            totalAmount\n          }\n        }\n      }\n    "
    ]);
    helpers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getV1History = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var skip, where, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skip = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, where = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        dist_default()(endpoints/* GRAPH_API_PREDICTION_V1 */.Kt, (0,dist.gql)(helpers_templateObject()), {
                            skip: skip,
                            where: where
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.bets
                    ];
            }
        });
    });
    return function getV1History() {
        return _ref.apply(this, arguments);
    };
}();
var getAllV1History = function() {
    var where = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new Promise(function(resolve, reject) {
        var bets = {};
        var getHistoryChunk = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(skip) {
                var betHistory, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                getV1History(skip, where)
                            ];
                        case 1:
                            betHistory = _state.sent();
                            bets[skip] = betHistory;
                            if (betHistory.length === 0) {
                                resolve(flatten_default()(Object.values(bets)));
                            } else {
                                getHistoryChunk(skip + 1000);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            reject(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getHistoryChunk(skip) {
                return _ref.apply(this, arguments);
            };
        }();
        getHistoryChunk(0);
    });
};

;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/NothingToClaimModal.tsx




function NothingToClaimModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n"
    ]);
    NothingToClaimModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NothingToClaimModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -116px; // line up bunny at the top of the modal\n  left: 0px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    NothingToClaimModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var NothingToClaimModal_Modal = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-172d40ae-0"
})(NothingToClaimModal_templateObject());
var NothingToClaimModal_BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-172d40ae-1"
})(NothingToClaimModal_templateObject1());
var NothingToClaimModal_CollectRoundWinningsModal = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,react.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react.useState)([]), history = ref1[0], setHistory = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        var header = [
            "Round",
            "Result",
            "Your Position",
            "Bet Amount",
            "Transaction",
            "Claimed Transaction",
            "Lock Price",
            "Close Price",
            "Total Bets",
            "Total Amount",
            "Round Failed", 
        ].join(",");
        var rows = history.reduce(function(accum, bet) {
            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                [
                    bet.round.epoch,
                    bet.round.position,
                    bet.position,
                    bet.amount,
                    bet.hash,
                    bet.claimedHash || "",
                    bet.round.lockPrice,
                    bet.round.closePrice,
                    bet.round.totalBets,
                    bet.round.totalAmount,
                    bet.round.failed, 
                ].join(","), 
            ]);
        }, []);
        var anchor = document.createElement("a");
        var blob = new Blob([
            "".concat(header, "\n").concat(rows.join("\n"))
        ], {
            type: "text/csv;charset=utf-8;"
        });
        anchor.href = URL.createObjectURL(blob);
        anchor.target = "_blank";
        anchor.download = "pancakeswap-prediction-v1-history.csv";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };
    (0,react.useEffect)(function() {
        var fetchAllHistory = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsFetching(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                getAllV1History({
                                    user: account.toLowerCase()
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            setHistory(response);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Unable to fetch history", error);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsFetching(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAllHistory() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) {
            fetchAllHistory();
        }
    }, [
        account,
        setHistory,
        setIsFetching
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NothingToClaimModal_Modal, {
        $minWidth: "288px",
        position: "relative",
        mt: "124px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NothingToClaimModal_BunnyDecoration, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/decorations/prize-bunny.png",
                    alt: "bunny decoration",
                    height: "124px",
                    width: "168px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("Nothing to Collect")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        children: t("You have no unclaimed v0.1 prizes.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        mb: "24px",
                        children: t("Download your v0.1 Prediction history below.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleClick,
                        isLoading: isFetching,
                        children: !isFetching ? t("Download .CSV") : t("Downloading...")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NothingToClaimModal = (NothingToClaimModal_CollectRoundWinningsModal);

;// CONCATENATED MODULE: ./src/views/Predictions/components/v1/V1ClaimCheck.tsx




function V1ClaimCheck_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n  justify-content: space-between;\n  padding: 16px;\n"
    ]);
    V1ClaimCheck_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var StyledClaimCheck = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e51eec9d-0"
})(V1ClaimCheck_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ClaimCheck = function() {
    var ref = (0,react.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react.useState)([]), history = ref1[0], setHistory = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var predictionsV1Address = (0,react.useMemo)(function() {
        return (0,addressHelpers/* getPredictionsV1Address */.wA)();
    }, []);
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectRoundWinningsModal, {
        predictionsAddress: predictionsV1Address,
        token: tokens_src/* bscTokens.bnb */.ds.bnb,
        dispatch: dispatch,
        history: history,
        isLoadingHistory: isFetching,
        isV1Claim: true,
        price: price
    }), false, true, "CollectRoundWinningsModalV1"), 1), onPresentCollectWinningsModal = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NothingToClaimModal, {})), 1), onPresentNothingToClaimModal = ref3[0];
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var betHistory, unclaimedBets, transformer, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsFetching(true);
                        return [
                            4,
                            getAllV1History({
                                user: account.toLowerCase(),
                                claimed: false
                            })
                        ];
                    case 1:
                        betHistory = _state.sent();
                        unclaimedBets = betHistory.filter(function(bet) {
                            return bet.round.position === bet.position || bet.round.failed === true;
                        });
                        if (unclaimedBets.length > 0) {
                            transformer = (0,helpers/* transformBetResponse */.ld)(tokens_src/* bscTokens.bnb */.ds.bnb);
                            setHistory(unclaimedBets.map(transformer));
                            onPresentCollectWinningsModal();
                        } else {
                            onPresentNothingToClaimModal();
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Unable to check v1 history", error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsFetching(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledClaimCheck, {
        onClick: account ? handleClick : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Showing history for Prediction v0.2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "primary",
                                children: t("Check for unclaimed v0.1 winnings")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                color: "primary",
                                width: "24px"
                            })
                        ]
                    })
                ]
            }),
            isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var V1ClaimCheck = (ClaimCheck);

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(69077);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/RoundsTab/AllFilter.tsx

function AllFilter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-collapse {\n    border: none !important;\n\n    .ant-collapse-item {\n      border: none;\n\n      .ant-collapse-header {\n        align-items: center !important;\n      }\n\n      & + .ant-collapse-item {\n        border-top: 1px solid ",
        ";\n      }\n\n      .ant-collapse-content {\n        border: none;\n\n        .ant-collapse-content-box {\n          background: ",
        ";\n          padding: 24px;\n        }\n      }\n    }\n\n    .ant-collapse-item-active {\n      .ant-collapse-expand-icon svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n"
    ]);
    AllFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Panel = collapse/* default.Panel */.Z.Panel;
var StyledHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69917fd5-0"
})(AllFilter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var AllFilter = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref = (0,wagmi_dist/* useAccount */.mA)(), account = ref.address;
    var hasHistoryLoaded = (0,predictions_hooks/* useGetHasHistoryLoaded */.sz)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var ref1 = (0,useTooltip/* default */.Z)(t("Includes your original position and your winnings, minus the 5% fee"), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var handleClick = function() {
        dispatch((0,predictions/* fetchNodeHistory */.uP)({
            account: account,
            page: currentHistoryPage + 1
        }));
    };
    var v1Claim = token.symbol === "BNB" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V1ClaimCheck, {}) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHistory, {
        children: [
            v1Claim,
            orderBy_default()(bets, [
                "round.epoch"
            ], [
                "desc"
            ]).map(function(bet) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(History_HistoricalBet, {
                    bet: bet
                }, bet.round.epoch);
            }),
            hasBetHistory && !hasHistoryLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                py: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    scale: "sm",
                    onClick: handleClick,
                    disabled: isFetchingHistory,
                    children: t("View More")
                })
            })
        ]
    });
};
/* harmony default export */ var RoundsTab_AllFilter = (AllFilter);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./packages/wagmi/src/useWeb3React.ts
var useWeb3React = __webpack_require__(78909);
;// CONCATENATED MODULE: ./src/views/Predictions/components/History/RoundsTab/UnCollectedFilter.tsx

function UnCollectedFilter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    UnCollectedFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UnCollectedFilter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  margin-left: auto;\n  border-radius: ",
        ";\n  color: ",
        ";\n  width: ",
        ";\n  max-height: ",
        ";\n"
    ]);
    UnCollectedFilter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UnCollectedFilter_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 24px;\n"
    ]);
    UnCollectedFilter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UnCollectedFilter_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-collapse {\n    border: none !important;\n\n    .ant-collapse-item {\n      border: none;\n\n      .ant-collapse-header {\n        align-items: center !important;\n      }\n\n      & + .ant-collapse-item {\n        border-top: 1px solid ",
        ";\n      }\n\n      .ant-collapse-content {\n        border: none;\n\n        .ant-collapse-content-box {\n          background: ",
        ";\n          padding: 24px;\n        }\n      }\n    }\n\n    .ant-collapse-item-active {\n      .ant-collapse-expand-icon svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n"
    ]);
    UnCollectedFilter_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











// eslint-disable-next-line lodash/import-scope




var UnCollectedFilter_Panel = collapse/* default.Panel */.Z.Panel;
var ResultText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b91f27e4-0"
})(UnCollectedFilter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
var CollectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b91f27e4-1"
})(UnCollectedFilter_templateObject1(), function(param) {
    var rounded = param.rounded;
    return rounded || "8px";
}, function(param) {
    var textColor = param.textColor;
    return textColor || "white";
}, function(param) {
    var width = param.width;
    return width || "unset";
}, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight || "unset";
});
var StyledHistoryBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-b91f27e4-2"
})(UnCollectedFilter_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var UnCollectedFilter_StyledHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b91f27e4-3"
})(UnCollectedFilter_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var UnCollectedFilter = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,useWeb3React/* useWeb3React */.G)().account;
    var hasHistoryLoaded = (0,predictions_hooks/* useGetHasHistoryLoaded */.sz)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var handleClick = function() {
        dispatch((0,predictions/* fetchNodeHistory */.uP)({
            account: account,
            page: currentHistoryPage + 1
        }));
    };
    var v1Claim = token.symbol === "BNB" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V1ClaimCheck, {}) : null;
    var currentFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    switch(currentFilter){
        case types/* HistoryFilter.ALL */.dZ.ALL:
            break;
        case types/* HistoryFilter.COLLECTED */.dZ.COLLECTED:
            break;
        case types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED:
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnCollectedFilter_StyledHistory, {
        children: [
            v1Claim,
            (0,lodash.orderBy)(bets, [
                "round.epoch"
            ], [
                "desc"
            ]).map(function(bet) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(History_HistoricalBet, {
                    bet: bet
                }, bet.round.epoch);
            })
        ]
    });
};
/* harmony default export */ var RoundsTab_UnCollectedFilter = (UnCollectedFilter);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/RoundsTab/RoundsTab.tsx

function RoundsTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    RoundsTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoundsTab_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  margin-left: auto;\n  border-radius: ",
        ";\n  color: ",
        ";\n  width: ",
        ";\n  max-height: ",
        ";\n"
    ]);
    RoundsTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoundsTab_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 24px;\n"
    ]);
    RoundsTab_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RoundsTab_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-collapse {\n    border: none !important;\n\n    .ant-collapse-item {\n      border: none;\n\n      .ant-collapse-header {\n        align-items: center !important;\n      }\n\n      & + .ant-collapse-item {\n        border-top: 1px solid ",
        ";\n      }\n\n      .ant-collapse-content {\n        border: none;\n\n        .ant-collapse-content-box {\n          background: ",
        ";\n          padding: 24px;\n        }\n      }\n    }\n\n    .ant-collapse-item-active {\n      .ant-collapse-expand-icon svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n"
    ]);
    RoundsTab_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var RoundsTab_Panel = collapse/* default.Panel */.Z.Panel;
var RoundsTab_ResultText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-cf34f365-0"
})(RoundsTab_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
var RoundsTab_CollectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-cf34f365-1"
})(RoundsTab_templateObject1(), function(param) {
    var rounded = param.rounded;
    return rounded || "8px";
}, function(param) {
    var textColor = param.textColor;
    return textColor || "white";
}, function(param) {
    var width = param.width;
    return width || "unset";
}, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight || "unset";
});
var RoundsTab_StyledHistoryBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-cf34f365-2"
})(RoundsTab_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var RoundsTab_StyledHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf34f365-3"
})(RoundsTab_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var RoundsTab = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var hasHistoryLoaded = (0,predictions_hooks/* useGetHasHistoryLoaded */.sz)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var handleClick = function() {
        dispatch((0,predictions/* fetchNodeHistory */.uP)({
            account: account,
            page: currentHistoryPage + 1
        }));
    };
    var v1Claim = token.symbol === "BNB" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V1ClaimCheck, {}) : null;
    var currentFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    var activeFilter = null;
    switch(currentFilter){
        case types/* HistoryFilter.ALL */.dZ.ALL:
            activeFilter = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsTab_AllFilter, {
                hasBetHistory: hasBetHistory,
                bets: bets
            });
            break;
        case types/* HistoryFilter.COLLECTED */.dZ.COLLECTED:
            activeFilter = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsTab_AllFilter, {
                hasBetHistory: hasBetHistory,
                bets: bets
            });
            break;
        case types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED:
            activeFilter = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsTab_UnCollectedFilter, {
                hasBetHistory: hasBetHistory,
                bets: bets
            });
            break;
        default:
            activeFilter = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsTab_AllFilter, {
                hasBetHistory: hasBetHistory,
                bets: bets
            });
    }
    return hasBetHistory ? activeFilter : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            v1Claim,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                p: "24px",
                pt: 0,
                pb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        size: "lg",
                        textAlign: "center",
                        mb: "8px",
                        children: t("No prediction history available")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        textAlign: "center",
                        children: t("Make sure you're connected to the correct wallet to see the history.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundsTab_RoundsTab = (RoundsTab);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlChartStyles.tsx
// @ts-nocheck
/**
 * There is ts-nocheck at the top of this file for the following reasons:
 * 1. You can't ignore block in TS at the moment https://stackoverflow.com/questions/51145180/how-to-use-ts-ignore-for-a-block
 * 2. Interpolations in keyframes are indeed supported and work fine https://github.com/styled-components/styled-components/issues/2263
 * But TypeScript definitions are not updated to reflect that - https://github.com/DefinitelyTyped/DefinitelyTyped/issues/48907
 * 3. Since this error is in the middle of a template string there is no way to add @ts-ignore on just that one line
 * without also messing prettier.
 *
 * I'll leave TODO: comment here to check back later if there is update to types
 *
 */ 
function PnlChartStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    stroke-dasharray: 0, 389.55\n  }\n  to {\n    stroke-dasharray: ",
        " 389.55;\n  }\n"
    ]);
    PnlChartStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    stroke-dashoffset: 0\n  }\n  to {\n    stroke-dashoffset: ",
        ";\n  }\n"
    ]);
    PnlChartStyles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 140px;\n  height: 140px;\n  transform: rotate(-90deg);\n"
    ]);
    PnlChartStyles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke-width: 16;\n  stroke-dasharray: ",
        ";\n"
    ]);
    PnlChartStyles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke: ",
        ";\n  animation: ",
        " 1s ease;\n"
    ]);
    PnlChartStyles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PnlChartStyles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* stroke: #31d0aa; */\n  stroke: ",
        ";\n  stroke-dashoffset: ",
        ";\n  animation: ",
        " 1s ease, ",
        " 1s ease;\n"
    ]);
    PnlChartStyles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 140px;\n  height: 140px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var DrawAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(PnlChartStyles_templateObject(), function(param) {
    var length = param.length;
    return length;
});
var OffsetAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(PnlChartStyles_templateObject1(), function(props) {
    return -props.offset;
});
var SVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-c2a36495-0"
})(PnlChartStyles_templateObject2());
var DefaultSlice = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-c2a36495-1"
})(PnlChartStyles_templateObject3(), function(props) {
    return "".concat(props.length, " 389.55");
});
var LostSlice = (0,styled_components_browser_esm/* default */.ZP)(DefaultSlice).withConfig({
    componentId: "sc-c2a36495-2"
})(PnlChartStyles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.failure;
}, DrawAnimation);
var WonSlice = (0,styled_components_browser_esm/* default */.ZP)(DefaultSlice).withConfig({
    componentId: "sc-c2a36495-3"
})(PnlChartStyles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
}, function(props) {
    return -props.offset;
}, DrawAnimation, OffsetAnimation);
var PnlChartStyles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2a36495-4"
})(_templateObject6());
var PnlChartStyles_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2a36495-5"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlChart.tsx




// 2 * Pi * R
var CIRCUMFERENCE = 389.55;
var PnlChart = function(param) {
    var lost = param.lost, won = param.won;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var percentageWon = won * 100 / (lost + won);
    var percentageWonDisplay = !Number.isNaN(percentageWon) ? "".concat(percentageWon.toFixed(2), "%") : "0%";
    var paintLost = lost / (won + lost) * CIRCUMFERENCE;
    var paintWon = CIRCUMFERENCE - paintLost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PnlChartStyles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG, {
                viewBox: "0 0 140 140",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LostSlice, {
                        r: "62",
                        cx: "70",
                        cy: "70",
                        length: paintLost
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WonSlice, {
                        r: "62",
                        cx: "70",
                        cy: "70",
                        length: paintWon,
                        offset: paintLost
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PnlChartStyles_Info, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        lineHeight: "18px",
                        children: t("Won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontWeight: 700,
                        fontSize: "14px",
                        lineHeight: "21px",
                        children: [
                            won,
                            "/",
                            won + lost
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        lineHeight: "140%",
                        color: "white60",
                        children: percentageWonDisplay
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PnlTab_PnlChart = (PnlChart);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/SummaryRow.tsx





var summaryTypeColors = {
    won: "success",
    lost: "failure",
    entered: "text"
};
var summaryTypeSigns = {
    won: "",
    lost: "-",
    entered: ""
};
var SummaryRow = function(param) {
    var type = param.type, summary = param.summary, bnbBusdPrice = param.bnbBusdPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var color = summaryTypeColors[type];
    var _type = summary[type], rounds = _type.rounds, amount = _type.amount;
    var totalRounds = summary.entered.rounds;
    var roundsInPercents = (rounds * 100 / totalRounds).toFixed(2);
    var typeTranslationKey = type.charAt(0).toUpperCase() + type.slice(1);
    var displayAmount = type === "won" ? summary[type].payout : amount;
    var amountInUsd = bnbBusdPrice * Number(displayAmount);
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var roundsInPercentsDisplay = !Number.isNaN(parseFloat(roundsInPercents)) ? "".concat(roundsInPercents, "%") : "0%";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "16px",
                mb: "4px",
                fontSize: "14px",
                children: t(typeTranslationKey)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "2",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontWeight: 700,
                                fontSize: "14px",
                                color: color,
                                children: [
                                    rounds,
                                    " ",
                                    rounds > 1 ? "rounds" : "round"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                textTransform: "capitalize",
                                color: "white60",
                                children: type === "entered" ? t("Total").toLocaleLowerCase() : roundsInPercentsDisplay
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "3",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: 700,
                                fontSize: "14px",
                                color: color,
                                children: "".concat(summaryTypeSigns[type]).concat(formatBnb(displayAmount, 2), " FTM")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                textTransform: "capitalize",
                                color: "white60",
                                children: formatUsdPro(amountInUsd, 2)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PnlTab_SummaryRow = (SummaryRow);

;// CONCATENATED MODULE: ./src/views/Predictions/components/History/PnlTab/PnlTab.tsx

function PnlTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 1px;\n  margin: 24px auto;\n  width: 100%;\n"
    ]);
    PnlTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PnlTab_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 36px;\n  font-size: 14px;\n  font-weight: 500;\n  gap: 8px;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    PnlTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var PnlTab_Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d5e622fc-0"
})(PnlTab_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
});
var initialPnlSummary = {
    won: {
        rounds: 0,
        amount: 0,
        payout: 0,
        bestRound: {
            id: "0",
            payout: 0,
            multiplier: 0
        }
    },
    lost: {
        rounds: 0,
        amount: 0
    },
    entered: {
        rounds: 0,
        amount: 0
    }
};
var WonButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-d5e622fc-1"
})(PnlTab_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.failure;
});
var getPnlSummary = function(bets, currentEpoch) {
    return bets.reduce(function(summary, bet) {
        var roundResult = (0,helpers/* getRoundResult */.yz)(bet, currentEpoch);
        if (roundResult === helpers/* Result.WIN */.x4.WIN) {
            var payout = getNetPayout(bet, config/* REWARD_RATE */.Ck);
            var bestRound = summary.won.bestRound;
            if (payout > bestRound.payout) {
                var _round = bet.round, bullAmount = _round.bullAmount, bearAmount = _round.bearAmount, totalAmount = _round.totalAmount;
                var multiplier = getMultiplier(totalAmount, bet.position === types/* BetPosition.BULL */.Tu.BULL ? bullAmount : bearAmount);
                bestRound = {
                    id: bet.round.epoch.toString(),
                    payout: payout,
                    multiplier: multiplier
                };
            }
            return {
                won: {
                    rounds: summary.won.rounds + 1,
                    amount: summary.won.amount + bet.amount,
                    payout: summary.won.payout + payout,
                    bestRound: bestRound
                },
                entered: {
                    rounds: summary.entered.rounds + 1,
                    amount: summary.entered.amount + bet.amount
                },
                lost: summary.lost
            };
        }
        if (roundResult === helpers/* Result.LOSE */.x4.LOSE || roundResult === helpers/* Result.HOUSE */.x4.HOUSE) {
            return {
                lost: {
                    rounds: summary.lost.rounds + 1,
                    amount: summary.lost.amount + bet.amount
                },
                entered: {
                    rounds: summary.entered.rounds + 1,
                    amount: summary.entered.amount + bet.amount
                },
                won: summary.won
            };
        }
        // Ignore Canceled and Live rounds
        return summary;
    }, initialPnlSummary);
};
var PnlTab = function(param) {
    var hasBetHistory = param.hasBetHistory, bets = param.bets;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var bnbBusdPrice = Number(web3_min_default().utils.fromWei(price.toString())) * 10e9;
    // const bnbBusdPrice = tokenInfo?.[0]?.OPX?.price || 0
    // console.log('price OP', bnbBusdPrice)
    var summary = getPnlSummary(bets, currentEpoch);
    var netResultAmount = summary.won.payout - summary.lost.amount;
    var netResultIsPositive = netResultAmount > 0;
    var avgPositionEntered = summary.entered.amount / summary.entered.rounds;
    var avgBnbWonPerRound = netResultAmount / summary.entered.rounds;
    var avgBnbWonIsPositive = avgBnbWonPerRound > 0;
    // Guard in case user has only lost rounds
    var hasBestRound = summary.won.bestRound.payout !== 0;
    var netResultInUsd = bnbBusdPrice * Number(netResultAmount);
    var avgBnbWonInUsd = bnbBusdPrice * Number(avgBnbWonPerRound);
    var avgBnbWonInUsdDisplay = !Number.isNaN(avgBnbWonInUsd) ? "".concat(formatUsdPro(Math.abs(avgBnbWonInUsd), 2)) : "$0.00";
    var betRoundInUsd = bnbBusdPrice * Number(summary.won.bestRound.payout);
    var avgPositionEnteredInUsd = bnbBusdPrice * Number(avgPositionEntered);
    var avgPositionEnteredInUsdDisplay = !Number.isNaN(avgPositionEnteredInUsd) ? "".concat(formatUsdPro(Math.abs(avgPositionEnteredInUsd), 2)) : "$0.00";
    // console.log('hasBetHistory', hasBetHistory)
    return hasBetHistory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: "24px",
        pt: 0,
        pb: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                fontSize: "16px",
                color: "white",
                fontWeight: 700,
                pb: "12px",
                children: t("Your history")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_PnlChart, {
                        lost: summary.lost.rounds,
                        won: summary.won.rounds
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        pl: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: 700,
                                fontSize: "14px",
                                children: t("Net results")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: 700,
                                fontSize: "24px",
                                lineHeight: "36px",
                                color: netResultIsPositive ? "success" : "failure",
                                children: "".concat(netResultIsPositive ? "+" : "").concat(formatBnb(netResultAmount, 2), " FTM")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "white60",
                                children: "".concat(formatUsdPro(Math.abs(netResultInUsd), 2))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "24px",
                        fontSize: "14px",
                        children: t("Average return / round")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        my: "4px",
                        fontWeight: 700,
                        color: avgBnbWonIsPositive ? "success" : "failure",
                        children: "".concat(avgBnbWonIsPositive ? "+" : "").concat(formatBnb(avgBnbWonPerRound, 2), " FTM")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "white60",
                        children: avgBnbWonInUsdDisplay
                    }),
                    hasBestRound && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "16px",
                                fontSize: "14px",
                                children: t("Best round: #%roundId%", {
                                    roundId: summary.won.bestRound.id
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                my: "4px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontWeight: 700,
                                        fontSize: "14px",
                                        color: "primary",
                                        children: "+".concat(formatBnb(summary.won.bestRound.payout, 2), " FTM")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        ml: "4px",
                                        fontWeight: 400,
                                        fontSize: "12px",
                                        children: [
                                            "(",
                                            summary.won.bestRound.multiplier.toFixed(2),
                                            "x)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "white60",
                                children: "$".concat(betRoundInUsd.toFixed(2))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "16px",
                        fontSize: "14px",
                        children: t("Average position entered / round")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        my: "4px",
                        fontWeight: 700,
                        fontSize: "14px",
                        children: "".concat(formatBnb(avgPositionEntered, 2), " FTM")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "white60",
                        children: avgPositionEnteredInUsdDisplay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "won",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "lost",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_SummaryRow, {
                        type: "entered",
                        summary: summary,
                        bnbBusdPrice: bnbBusdPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        mt: "24px",
                        justifyContent: "center",
                        alignItems: "stretch",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            as: Link/* default */.Z,
                            href: "".concat((0,utils/* getBlockExploreLink */.C)(account, "address"), "#internaltx"),
                            external: true,
                            scale: "md",
                            variant: "success",
                            style: {
                                fontSize: 14,
                                width: "100%"
                            },
                            children: t("View Reclaimed & Won")
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: "24px",
        pt: 0,
        pb: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                size: "lg",
                textAlign: "center",
                mb: "8px",
                children: t("No prediction history available")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                textAlign: "center",
                children: t("Make sure you're connected to the correct wallet to see the history.")
            })
        ]
    });
};
/* harmony default export */ var PnlTab_PnlTab = (PnlTab);

;// CONCATENATED MODULE: ./src/views/Predictions/History.tsx

function History_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  z-index: 99;\n"
    ]);
    History_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function History_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n"
    ]);
    History_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function History_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  display: flex;\n  left: 0;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"
    ]);
    History_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var History_StyledHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e6e87af-0"
})(History_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.historyBg;
});
var BetWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e6e87af-1"
})(History_templateObject1());
var SpinnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e6e87af-2"
})(History_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.card.background;
});
var History = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var historyFilter = (0,predictions_hooks/* useGetHistoryFilter */.J7)();
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var currentHistoryPage = (0,predictions_hooks/* useGetCurrentHistoryPage */.Gc)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var bets = (0,predictions_hooks/* useGetHistory */.pw)();
    var ref = (0,react.useState)(HistoryTabs.ROUNDS), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if (account && isHistoryPaneOpen) {
            dispatch((0,predictions/* fetchNodeHistory */.uP)({
                account: account
            }));
        }
    }, [
        account,
        currentEpoch,
        isHistoryPaneOpen,
        dispatch
    ]);
    var results = (0,helpers/* getFilteredBets */.fq)(bets, historyFilter);
    var hasBetHistory = results && results.length > 0;
    var activeTabComponent = null;
    switch(activeTab){
        case HistoryTabs.PNL:
            activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(PnlTab_PnlTab, {
                hasBetHistory: hasBetHistory,
                bets: results
            });
            break;
        case HistoryTabs.ROUNDS:
        default:
            activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsTab_RoundsTab, {
                hasBetHistory: hasBetHistory,
                bets: results
            });
            break;
    }
    if (!account) {
        activeTabComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            mt: "32px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mt: "8px",
                    children: t("Connect your wallet to view your prediction history")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(History_StyledHistory, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(History_Header, {
                activeTab: activeTab,
                setActiveTab: setActiveTab
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BetWrapper, {
                children: isFetchingHistory && currentHistoryPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        size: 72
                    })
                }) : activeTabComponent
            })
        ]
    });
};
/* harmony default export */ var Predictions_History = (History);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(40025);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/LogoOpx.tsx
var LogoOpx = __webpack_require__(64876);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CalculateOPX.tsx
var CalculateOPX = __webpack_require__(58213);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Predictions/RoundMultiplierArrows.tsx






var RoundMultiplierDownArrow = function(_param) {
    var isActive = _param.isActive, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isActive"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var fill = theme.colors[isActive ? "failure" : "tertiary"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: "65px",
        width: "240px",
        viewBox: "0 0 240 65"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_i)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.0001 15.7243L10.0003 1H234L234 15.7247C234 22.4864 229.749 28.5181 223.381 30.7923L138.48 61.1141C127.823 64.9203 116.177 64.9203 105.519 61.1141L20.6188 30.7924C14.2508 28.5181 10.0001 22.4862 10.0001 15.7243Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_i",
                    x: "10.0001",
                    y: "1",
                    width: "224",
                    height: "62.9688",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow"
                        })
                    ]
                })
            })
        ]
    }));
};
var RoundMultiplierUpArrow = function(_param) {
    var isActive = _param.isActive, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isActive"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var fill = theme.colors[isActive ? "success" : "tertiary"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        height: "65px",
        width: "240px",
        viewBox: "0 0 240 65"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_i)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.0001 49.2757L10.0003 64H234L234 49.2753C234 42.5136 229.749 36.4819 223.381 34.2077L138.48 3.8859C127.823 0.0796983 116.177 0.0796931 105.519 3.8859L20.6188 34.2076C14.2508 36.4819 10.0001 42.5138 10.0001 49.2757Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_i",
                    x: "10.0001",
                    y: "1.03125",
                    width: "224",
                    height: "62.9688",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow"
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag_Tag = __webpack_require__(22769);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CheckmarkCircle.tsx
var CheckmarkCircle = __webpack_require__(39398);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/EnteredTag.tsx









var EnteredTag = function(param) {
    var amount = param.amount, _hasClaimed = param.hasClaimed, hasClaimed = _hasClaimed === void 0 ? false : _hasClaimed, multiplier = param.multiplier;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,ConfigProvider/* useConfig */.ZR)(), token = ref.token, displayedDecimals = ref.displayedDecimals;
    var formattedAmount = (0,react.useMemo)(function() {
        var tokenAmount;
        if (hasClaimed) {
            if (amount) {
                var multiplierNumber = parseFloat(multiplier);
                tokenAmount = bignumber/* BigNumber.from */.O$.from((0,bigNumber/* ethersToBigNumber */.i9)(amount).times(Number.isFinite(multiplierNumber) ? multiplierNumber * config/* REWARD_RATE */.Ck : 1).toFixed(0));
            }
        } else {
            tokenAmount = amount;
        }
        return (0,Predictions_helpers/* formatBnbv2 */.rc)(tokenAmount, displayedDecimals);
    }, [
        amount,
        displayedDecimals,
        hasClaimed,
        multiplier
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: "".concat(formattedAmount, " FTM")
    }), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltipVisible = ref1.tooltipVisible, tooltip = ref1.tooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag/* default */.Z, {
                    fontWeight: "500",
                    textTransform: "uppercase",
                    startIcon: hasClaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle/* default */.Z, {
                        width: "24px"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle/* default */.Z, {
                        width: "24px"
                    }),
                    children: hasClaimed ? t("Claimed") : t("Entered")
                })
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_EnteredTag = (EnteredTag);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/MultiplierArrow.tsx

function MultiplierArrow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n  margin: 0 auto;\n  width: 240px;\n"
    ]);
    MultiplierArrow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultiplierArrow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  left: 0;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"
    ]);
    MultiplierArrow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MultiplierArrow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 10;\n"
    ]);
    MultiplierArrow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1e52e33-0"
})(MultiplierArrow_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1e52e33-1"
})(MultiplierArrow_templateObject1());
var EnteredTagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1e52e33-2"
})(MultiplierArrow_templateObject2());
var getTextColor = function() {
    var fallback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "textSubtle";
    return function(isActive, isDisabled, isHouse) {
        if (isHouse) {
            return "secondary";
        }
        if (isDisabled) {
            return "white20";
        }
        if (isActive) {
            return "white";
        }
        return fallback;
    };
};
var MultiplierArrow = function(param) {
    var betAmount = param.betAmount, multiplier = param.multiplier, _hasEntered = param.hasEntered, hasEntered = _hasEntered === void 0 ? false : _hasEntered, _hasClaimed = param.hasClaimed, hasClaimed = _hasClaimed === void 0 ? false : _hasClaimed, _betPosition = param.betPosition, betPosition = _betPosition === void 0 ? types/* BetPosition.BULL */.Tu.BULL : _betPosition, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _isHouse = param.isHouse, isHouse = _isHouse === void 0 ? false : _isHouse, _isExpired = param.isExpired, isExpired = _isExpired === void 0 ? false : _isExpired;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var upColor = getTextColor("success")(isActive, isDisabled, isHouse);
    var downColor = getTextColor("failure")(isActive, isDisabled, isHouse);
    var textColor = getTextColor()(isActive, isDisabled, isHouse);
    var multiplierText = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: isExpired ? "#060303" : betPosition === types/* BetPosition.BULL */.Tu.BULL ? "#060303" : "white",
                    bold: true,
                    lineHeight: "21px !important",
                    children: multiplier !== undefined ? "".concat(multiplier, "x") : "-"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: isExpired ? "#060303" : betPosition === types/* BetPosition.BULL */.Tu.BULL ? "#060303" : "white",
                    lineHeight: "21px !important",
                    ml: "4px",
                    children: t("Payout")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: isExpired ? "#FFFFFF" : "white",
                    bold: true,
                    lineHeight: "21px !important",
                    children: multiplier !== undefined ? "".concat(multiplier, "x") : "-"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: isExpired ? "#FFFFFF" : "white",
                    lineHeight: "21px !important",
                    ml: "4px",
                    children: t("Payout")
                })
            ]
        })
    });
    var getEnteredTag = function(position) {
        if (!hasEntered) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnteredTagWrapper, {
            style: position,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_EnteredTag, {
                amount: betAmount,
                hasClaimed: hasClaimed,
                multiplier: multiplier
            })
        });
    };
    if (betPosition === types/* BetPosition.BEAR */.Tu.BEAR) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: "-1px",
            position: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundMultiplierDownArrow, {
                        isActive: isActive
                    }),
                    getEnteredTag({
                        bottom: 0,
                        right: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            !isDisabled && multiplierText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                fontSize: "16px",
                                fontWeight: 700,
                                lineHeight: "24px",
                                mb: "8px",
                                color: downColor,
                                textTransform: "uppercase",
                                children: t("Down")
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: "-1px",
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundMultiplierUpArrow, {
                    isActive: isActive
                }),
                getEnteredTag({
                    top: 0,
                    left: 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "24px",
                            color: isExpired ? "#060303" : betPosition === types/* BetPosition.BULL */.Tu.BULL ? "#060303" : "white",
                            textTransform: "uppercase",
                            children: t("Up")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "24px",
                            color: isExpired ? "#03F5AE" : upColor,
                            textTransform: "uppercase",
                            children: t("Up")
                        }),
                        !isDisabled && multiplierText
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RoundCard_MultiplierArrow = (MultiplierArrow);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CardHeader.tsx

function CardHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  height: ",
        ";\n  padding: ",
        ";\n  padding: 16px 24px;\n"
    ]);
    CardHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-self: center;\n"
    ]);
    CardHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var HEADER_HEIGHT = "65px";
// Used to get the gradient for the card border, which depends on the header color to create the illusion
// that header is overlapping the 1px card border.
// 'live' is not included into the switch case because it has isActive border style
var getBorderBackground = function(theme, status) {
    var gradientStopPoint = "calc(".concat(HEADER_HEIGHT, " + 1px)");
    switch(status){
        case "calculating":
            return "linear-gradient(transparent ".concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, "), ").concat(theme.colors.gradientCardHeader);
        case "canceled":
            return "linear-gradient(".concat(theme.colors.warning, " ").concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, ")");
        case "next":
            return "linear-gradient(".concat(theme.colors.secondary, " ").concat(gradientStopPoint, ", ").concat(theme.colors.cardBorder, " ").concat(gradientStopPoint, ")");
        case "expired":
        case "soon":
        default:
            return theme.colors.cardBorder;
    }
};
var CardHeader_getBackgroundColor = function(theme, status) {
    switch(status){
        case "canceled":
            return theme.colors.warning;
        case "next":
            return theme.colors.success;
        case "calculating":
        case "expired":
        case "soon":
        case "live":
            return theme.colors.cardHeaderBg;
        default:
            return theme.colors.cardBorder;
    }
};
var getTextColorByStatus = function(status, fallback) {
    switch(status){
        case "expired":
            return "white60";
        case "next":
        case "canceled":
            return "textMain";
        case "live":
            return "primary";
        case "calculating":
            return "text";
        case "soon":
            return "white";
        default:
            return fallback;
    }
};
var StyledCardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c75786c7-0"
})(CardHeader_templateObject(), function(param) {
    var theme = param.theme, status = param.status;
    return CardHeader_getBackgroundColor(theme, status);
}, HEADER_HEIGHT, function(param) {
    var status = param.status;
    return status === "live" ? "16px" : "8px";
});
var Round = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c75786c7-1"
})(CardHeader_templateObject1());
var CardHeader = function(param) {
    var status = param.status, title = param.title, epoch = param.epoch, icon = param.icon;
    var textColor = getTextColorByStatus(status, "text");
    // const isLive = status === 'live'
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardHeader, {
        status: status,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        className: "icon",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: textColor,
                        fontWeight: 700,
                        lineHeight: "21px",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Round, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontWeight: 500,
                    color: getTextColorByStatus(status, "textSubtle"),
                    textAlign: "center",
                    children: "#".concat(epoch)
                })
            })
        ]
    });
};
/* harmony default export */ var RoundCard_CardHeader = (CardHeader);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CalculatingCard.tsx

function CalculatingCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n"
    ]);
    CalculatingCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CalculatingCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  z-index: 2;\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    margin: -2px;\n    background-image: linear-gradient(to right top, #07f5ae 50%, #00000000, #00000000);\n    border-radius: inherit;\n    animation: rotation 1s linear infinite;\n    animation: ",
        " 3s linear infinite;\n  }\n"
    ]);
    CalculatingCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CalculatingCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  position: absolute;\n  inset: 0;\n  background-color: #191b2e;\n  border-radius: 50%;\n  z-index: 2;\n"
    ]);
    CalculatingCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var spinner = (0,styled_components_browser_esm/* keyframes */.F4)(CalculatingCard_templateObject());
var Loader = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-5d48a536-0"
})(CalculatingCard_templateObject1(), spinner);
var StyledCalculateOPXIcon = (0,styled_components_browser_esm/* default */.ZP)(CalculateOPX/* default */.Z).withConfig({
    componentId: "sc-5d48a536-1"
})(CalculatingCard_templateObject2());
var CalculatingCard = function(param) {
    var round = param.round, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, betAmount = param.betAmount;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,useTooltip/* default */.Z)(t("This round’s closing transaction has been submitted to the blockchain, and is awaiting confirmation."), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                borderBackground: getBorderBackground(theme, "calculating"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                        status: "calculating",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                            mr: "4px",
                            width: "21px"
                        }),
                        title: t("Calculating"),
                        epoch: round.epoch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                        p: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                isDisabled: true,
                                hasEntered: hasEnteredUp,
                                betAmount: betAmount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        mt: "8px",
                                        ref: targetRef,
                                        flexDirection: "column",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {
                                                mb: 16,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCalculateOPXIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        fontSize: "16px",
                                                        children: t("Calculating")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                        ml: "4px",
                                                        width: "24px"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                                isDisabled: true,
                                hasEntered: hasEnteredDown,
                                betAmount: betAmount
                            })
                        ]
                    })
                ]
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_CalculatingCard = (CalculatingCard);

;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useLedger.ts







var useLedger = function(epoch) {
    var ref = (0,react.useState)({
        amount: bignumber/* BigNumber.from */.O$.from(0),
        claimed: false
    }), ledger = ref[0], setLedger = ref[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var address = (0,ConfigProvider/* useConfig */.ZR)().address;
    (0,react.useEffect)(function() {
        var clear = setInterval(function() {
            var fetchRefundableStatus = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var predictionsContract, ref, claimed, amount;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                predictionsContract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                                return [
                                    4,
                                    predictionsContract.ledger(epoch, account)
                                ];
                            case 1:
                                ref = _state.sent(), claimed = ref.claimed, amount = ref.amount;
                                setLedger({
                                    amount: amount,
                                    claimed: claimed
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchRefundableStatus() {
                    return _ref.apply(this, arguments);
                };
            }();
            if (account) {
                fetchRefundableStatus();
            }
        }, 5000);
        return function() {
            return clearInterval(clear);
        };
    }, [
        account,
        address,
        epoch
    ]);
    return {
        ledger: ledger,
        setLedger: setLedger
    };
};
/* harmony default export */ var hooks_useLedger = (useLedger);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/CanceledRoundCard.tsx













var CanceledRoundCard = function(param) {
    var round = param.round;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var setIsRefundable = hooks_useIsRefundable(round.epoch).setIsRefundable;
    var ledger = hooks_useLedger(round.epoch).ledger;
    var epoch = round.epoch;
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsRefundable(false);
                return [
                    2
                ];
            });
        });
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        borderBackground: getBorderBackground(theme, "canceled"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "canceled",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                    width: "24px",
                    color: "textMain",
                    mr: 2
                }),
                title: t("Cancelled"),
                epoch: round.epoch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        isDisabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    color: "text",
                                    mb: "16px",
                                    children: t("Round Cancelled")
                                }),
                                ledger.amount.gt(0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReclaimPositionButton, {
                                    disabled: ledger.claimed,
                                    epoch: epoch,
                                    onSuccess: handleSuccess,
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                    fontWeight: 500,
                                    color: "success",
                                    href: "https://docs.mummy.finance/prediction/prediction-faq#market-pauses",
                                    external: true,
                                    children: t("Learn More")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        isDisabled: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_CanceledRoundCard = (CanceledRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/ExpiredRoundCard.tsx



function ExpiredRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* opacity: 0.7; */\n  transition: opacity 300ms;\n  &:before {\n    z-index: 10;\n    content: '';\n    position: absolute;\n\n    opacity: 0.7;\n    background: rgba(0, 0, 0, 0.7);\n    width: 100%;\n    height: 100%;\n    /* background: url('http://img42.imageshack.us/img42/1893/96c75664f7e94f9198ad113.png') no-repeat 0 0;  */\n  }\n  &:hover {\n    opacity: 1;\n  }\n  .card-enter-postition-down {\n    bottom: 0px;\n    top: unset;\n  }\n"
    ]);
    ExpiredRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExpiredRoundCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n  width: 100%;\n  top: 0;\n  right: 0;\n  left: 0;\n  gap: 24px;\n  z-index: 10000;\n  background: ",
        ";\n\n  height: fit-content;\n  bottom: 0;\n\n  > button {\n    flex: 1;\n    height: 36px;\n    color: black;\n  }\n"
    ]);
    ExpiredRoundCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var StyledExpiredRoundCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-4f107408-0"
})(ExpiredRoundCard_templateObject());
var CollectWinning = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4f107408-1"
})(ExpiredRoundCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.prize;
});
var ExpiredRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, hasClaimedUp = param.hasClaimedUp, hasClaimedDown = param.hasClaimedDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier, isActive = param.isActive;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var epoch = round.epoch, lockPrice = round.lockPrice, closePrice = round.closePrice;
    var betPosition = (0,Predictions_helpers/* getRoundPosition */.XW)(lockPrice, closePrice);
    var bufferSeconds = (0,predictions_hooks/* useGetBufferSeconds */.XM)();
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var ref = (0,predictions_hooks/* useCollectWinningModalProps */.Dh)(), history = ref.history, isLoadingHistory = ref.isLoadingHistory;
    var hasRoundFailed = (0,helpers/* getHasRoundFailed */.HJ)(round.oracleCalled, round.closeTimestamp, bufferSeconds);
    var isClaimable = (0,predictions_hooks/* useGetIsClaimable */.Wx)(epoch);
    if (hasRoundFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CanceledRoundCard, {
            round: round
        });
    }
    if (!closePrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CalculatingCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            betAmount: betAmount
        });
    }
    var cardProps = isActive ? {
        isActive: isActive
    } : {
        borderBackground: getBorderBackground(theme, "expired")
    };
    // useEffect(() => {
    //   onPresentClaimModal();
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpiredRoundCard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                    status: "expired",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                        mr: "4px",
                        width: "21px",
                        color: "white60"
                    }),
                    title: t("Expired"),
                    epoch: round.epoch
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                    p: "16px",
                    style: {
                        position: "relative"
                    },
                    children: [
                        isClaimable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectWinning, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "absolute",
                            className: "".concat(hasEnteredDown ? "card-enter-postition-down" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoOpx/* default */.Z, {
                                    width: 40,
                                    height: 40
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsButton, {
                                    hasClaimed: false,
                                    variant: "primary",
                                    px: "0",
                                    price: price || 0,
                                    style: {
                                        fontWeight: 700
                                    },
                                    children: t("Collect Winnings")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                            isExpired: true,
                            betAmount: betAmount,
                            multiplier: bullMultiplier,
                            isActive: betPosition === types/* BetPosition.BULL */.Tu.BULL,
                            hasEntered: hasEnteredUp,
                            hasClaimed: hasClaimedUp,
                            isHouse: betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResult_RoundResult, {
                            round: round,
                            hasFailed: hasRoundFailed
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                            betAmount: betAmount,
                            multiplier: bearMultiplier,
                            betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                            isActive: betPosition === types/* BetPosition.BEAR */.Tu.BEAR,
                            hasEntered: hasEnteredDown,
                            hasClaimed: hasClaimedDown,
                            isHouse: betPosition === types/* BetPosition.HOUSE */.Tu.HOUSE
                        })
                    ]
                })
            ]
        }))
    });
};
/* harmony default export */ var RoundCard_ExpiredRoundCard = (ExpiredRoundCard);

;// CONCATENATED MODULE: ./src/utils/getNow.ts
var getNow = function() {
    return Math.floor(Date.now() / 1000);
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/Progress.tsx + 1 modules
var Progress = __webpack_require__(79207);
;// CONCATENATED MODULE: ./src/components/RoundProgress.tsx




var RoundProgress = function(_param) {
    var lockTimestamp = _param.lockTimestamp, closeTimestamp = _param.closeTimestamp, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "lockTimestamp",
        "closeTimestamp"
    ]);
    var startMs = lockTimestamp * 1000;
    var endMs = closeTimestamp * 1000;
    var now = Date.now();
    var rawProgress = (now - startMs) / (endMs - startMs) * 100;
    var progress = rawProgress <= 100 ? rawProgress : 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, (0,src_object_spread/* default */.Z)({
        primaryStep: progress
    }, props));
};
/* harmony default export */ var components_RoundProgress = (RoundProgress);

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/LiveRoundPrice.tsx





var LiveRoundPrice = function(param) {
    var isBull = param.isBull, price = param.price;
    var priceAsNumber = (0,react.useMemo)(function() {
        return parseFloat((0,formatBalance/* formatBigNumberToFixed */.U1)(price, 4, 8));
    }, [
        price
    ]);
    var priceColor = isBull ? "success" : "failure";
    if (!Number.isFinite(priceAsNumber)) {
        return null;
    }
    if (price.lt(0)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            height: "36px",
            width: "94px"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        start: 0,
        preserveValue: true,
        delay: 0,
        end: priceAsNumber,
        prefix: "$",
        decimals: 4,
        duration: 1,
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                color: priceColor,
                fontSize: "18px",
                fontWeight: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: countUpRef
                })
            });
        }
    });
};
/* harmony default export */ var RoundCard_LiveRoundPrice = (/*#__PURE__*/(0,react.memo)(LiveRoundPrice));

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/LiveRoundCard.tsx



















var REFRESH_PRICE_BEFORE_SECONDS_TO_CLOSE = 2;
var LiveRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var lockPrice = round.lockPrice, totalAmount = round.totalAmount, lockTimestamp = round.lockTimestamp, closeTimestamp = round.closeTimestamp;
    var ref = (0,usePollOraclePrice/* default */.Z)(), price = ref.price, refresh = ref.refresh;
    var bufferSeconds = (0,predictions_hooks/* useGetBufferSeconds */.XM)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), minPriceUsdDisplayed = ref1.minPriceUsdDisplayed, displayedDecimals = ref1.displayedDecimals;
    var ref2 = (0,react.useState)(false), isCalculatingPhase = ref2[0], setIsCalculatingPhase = ref2[1];
    var isBull = lockPrice && price.gt(lockPrice);
    var priceDifference = (0,Predictions_helpers/* getPriceDifference */.kJ)(price, lockPrice);
    var hasRoundFailed = (0,helpers/* getHasRoundFailed */.HJ)(round.oracleCalled, round.closeTimestamp, bufferSeconds);
    var ref3 = (0,useTooltip/* default */.Z)(t("Last price from Chainlink Oracle"), {
        placement: "bottom"
    }), targetRef = ref3.targetRef, tooltip = ref3.tooltip, tooltipVisible = ref3.tooltipVisible;
    (0,react.useEffect)(function() {
        var secondsToClose = closeTimestamp ? closeTimestamp - getNow() : 0;
        if (secondsToClose > 0) {
            var refreshPriceTimeout = setTimeout(function() {
                refresh();
            }, (secondsToClose - REFRESH_PRICE_BEFORE_SECONDS_TO_CLOSE) * 1000);
            var calculatingPhaseTimeout = setTimeout(function() {
                setIsCalculatingPhase(true);
            }, secondsToClose * 1000);
            return function() {
                clearTimeout(refreshPriceTimeout);
                clearTimeout(calculatingPhaseTimeout);
            };
        }
        return undefined;
    }, [
        refresh,
        closeTimestamp
    ]);
    if (hasRoundFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CanceledRoundCard, {
            round: round
        });
    }
    if (isCalculatingPhase) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CalculatingCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            betAmount: betAmount
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        isActive: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "live",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {
                    mr: "8px",
                    color: "primary"
                }),
                title: t("LIVE"),
                epoch: round.epoch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoundProgress, {
                variant: "flat",
                scale: "sm",
                lockTimestamp: lockTimestamp,
                closeTimestamp: closeTimestamp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betAmount: betAmount,
                        multiplier: bullMultiplier,
                        hasEntered: hasEnteredUp,
                        isActive: isBull
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundResultBox, {
                        betPosition: isBull ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "white",
                                fontSize: "14px",
                                bold: true,
                                mb: "8px",
                                children: t("Last Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: "16px",
                                height: "36px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: targetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_LiveRoundPrice, {
                                            isBull: isBull,
                                            price: price
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                                        height: "100%",
                                        betPosition: isBull ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
                                        children: (0,Predictions_helpers/* formatUsdv2 */.pf)(priceDifference.abs(), minPriceUsdDisplayed, displayedDecimals)
                                    })
                                ]
                            }),
                            lockPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockPriceRow, {
                                lockPrice: lockPrice,
                                mb: "16px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                totalAmount: totalAmount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betAmount: betAmount,
                        multiplier: bearMultiplier,
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        hasEntered: hasEnteredDown,
                        isActive: !isBull
                    })
                ]
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var RoundCard_LiveRoundCard = (LiveRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/CardFlip.tsx


function CardFlip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  backface-visibility: hidden;\n  display: flex;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: z-index 600ms;\n  width: 100%;\n\n  & > div {\n    flex: 1;\n  }\n"
    ]);
    CardFlip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardFlip_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotateY(180deg);\n"
    ]);
    CardFlip_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardFlip_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n  transform: rotateY(",
        "deg);\n  transform-style: preserve-3d;\n  transition: transform 600ms;\n\n  ",
        " {\n    z-index: ",
        ";\n  }\n\n  ",
        " {\n    z-index: ",
        ";\n  }\n"
    ]);
    CardFlip_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardFlip_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  perspective: 1000px;\n  z-index: auto;\n"
    ]);
    CardFlip_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Front = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-0"
})(CardFlip_templateObject());
var Back = (0,styled_components_browser_esm/* default */.ZP)(Front).withConfig({
    componentId: "sc-709c61ff-1"
})(CardFlip_templateObject1());
var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-2"
})(CardFlip_templateObject2(), function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 180 : 0;
}, Front, function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 5 : 10;
}, Back, function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 10 : 5;
});
var StyledCardFlip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-709c61ff-3"
})(CardFlip_templateObject3());
var getComponents = function(children) {
    if (children.length !== 2) {
        throw new Error("CardFlip: Two children are required");
    }
    return children;
};
var CardFlip = function(param) {
    var isFlipped = param.isFlipped, height = param.height, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(getComponents(children), 2), front = ref[0], back = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardFlip, {
        style: {
            height: height
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            isFlipped: isFlipped,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Front, {
                    children: front
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Back, {
                    children: back
                })
            ]
        })
    });
};
/* harmony default export */ var components_CardFlip = (CardFlip);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var Card_CardHeader = __webpack_require__(55209);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(87844);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/OpusdToken.tsx
var OpusdToken = __webpack_require__(10439);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(39665);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(68118);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(94186);
// EXTERNAL MODULE: ./src/hooks/useCakeApprovalStatus.ts
var useCakeApprovalStatus = __webpack_require__(49729);
// EXTERNAL MODULE: ./src/hooks/useCakeApprove.tsx
var useCakeApprove = __webpack_require__(71850);
;// CONCATENATED MODULE: ./src/views/Predictions/components/FlexRow.tsx

function FlexRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 0 250px;\n\n  @media screen and (max-width: 1700px) {\n    padding: 16px 240px;\n  }\n\n  @media screen and (max-width: 1600px) {\n    padding: 16px 215px;\n  }\n\n  @media screen and (max-width: 1500px) {\n    padding: 16px 192px;\n  }\n\n  @media screen and (max-width: 1470px) {\n    padding: 24px 30px;\n  }\n\n  @media screen and (max-width: 1366px) {\n    padding: 24px 150px;\n  }\n\n  @media screen and (max-width: 1365px) {\n    padding: 24px;\n  }\n\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"
    ]);
    FlexRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FlexRow = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    alignItems: "center"
}).withConfig({
    componentId: "sc-20e44edd-0"
})(FlexRow_templateObject());
/* harmony default export */ var components_FlexRow = (FlexRow);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/SetPositionCard.tsx



function SetPositionCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 4px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n"
    ]);
    SetPositionCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SetPositionCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n\n  > * {\n    height: 100%;\n  }\n"
    ]);
    SetPositionCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SetPositionCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 140%; /* 16.8px */\n  padding: 8px;\n  height: unset;\n"
    ]);
    SetPositionCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SetPositionCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #03f5ae;\n  color: black;\n"
    ]);
    SetPositionCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}























var ButtonsContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aec95465-0"
})(SetPositionCard_templateObject());
var SetPositionHeaderCard = (0,styled_components_browser_esm/* default */.ZP)(Card_CardHeader/* default */.Z).withConfig({
    componentId: "sc-aec95465-1"
})(SetPositionCard_templateObject1());
var ButtonPercentItem = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-aec95465-2"
})(SetPositionCard_templateObject2());
var SubmitButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-aec95465-3"
})(SetPositionCard_templateObject3());
var dust = (0,lib_esm.parseUnits)("0.03", 18);
var percentShortcuts = [
    10,
    25,
    50,
    75
];
var getButtonProps = function(value, bnbBalance, minBetAmountBalance, pendingTx) {
    var hasSufficientBalance = function() {
        if (value.gt(0)) {
            return value.lte(bnbBalance);
        }
        return bnbBalance.gt(0);
    };
    if (!hasSufficientBalance()) {
        return {
            key: "Insufficient FTM balance",
            disabled: true
        };
    }
    if (value.eq(0)) {
        return {
            key: "Enter an amount",
            disabled: true
        };
    }
    if (value.lt(minBetAmountBalance)) {
        return {
            key: "Min amount: ".concat(web3_min_default().utils.fromWei(String(minBetAmountBalance)), " FTM"),
            disabled: true
        };
    }
    if (pendingTx) {
        return {
            key: "Confirming...",
            disabled: value.lt(minBetAmountBalance)
        };
    }
    return {
        key: "Confirm",
        disabled: value.lt(minBetAmountBalance)
    };
};
var getValueAsEthersBn = function(value) {
    var valueAsFloat = parseFloat(value);
    return Number.isNaN(valueAsFloat) ? bignumbers/* Zero */._Y : (0,lib_esm.parseUnits)(value);
};
var TOKEN_BALANCE_CONFIG = {
    BNB: useTokenBalance/* useGetBnbBalance */.nu,
    CAKE: useTokenBalance/* useGetCakeBalance */.Nn
};
var CURRENT_TOKEN = "BNB";
var SetPositionCard = function(param) {
    var position = param.position, togglePosition = param.togglePosition, epoch = param.epoch, onBack = param.onBack, onSuccess = param.onSuccess;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(0), percent = ref2[0], setPercent = ref2[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var minBetAmount = (0,predictions_hooks/* useGetMinBetAmount */.eI)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref3 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref3.fetchWithCatchTxError, isTxPending = ref3.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref4 = (0,ConfigProvider/* useConfig */.ZR)(), predictionsAddress = ref4.address, token = ref4.token;
    var predictionsContract = (0,useContract/* usePredictionsContract */.Tu)(predictionsAddress, token.symbol);
    var useTokenBalance = (0,react.useMemo)(function() {
        // return TOKEN_BALANCE_CONFIG[token.symbol]
        return TOKEN_BALANCE_CONFIG[CURRENT_TOKEN];
    }, [
        token.symbol
    ]);
    var ref5 = (0,useCakeApprovalStatus/* default */.Z)(token.symbol === "CAKE" ? predictionsAddress : null), isVaultApproved = ref5.isVaultApproved, setLastUpdated = ref5.setLastUpdated;
    var ref6 = (0,useCakeApprove/* default */.Z)(setLastUpdated, predictionsAddress, t("You can now start prediction")), handleApprove = ref6.handleApprove, pendingTx = ref6.pendingTx;
    // BNB prediction doesn't need approval
    // const doesCakeApprovePrediction = token.symbol === 'BNB' || isVaultApproved
    var doesCakeApprovePrediction = CURRENT_TOKEN === "BNB" || isVaultApproved;
    var ref7 = useTokenBalance(), bnbBalance = ref7.balance;
    var maxBalance = (0,react.useMemo)(function() {
        return bnbBalance.gt(dust) ? bnbBalance.sub(dust) : bignumbers/* Zero */._Y;
    }, [
        bnbBalance
    ]);
    var balanceDisplay = (0,formatBalance/* formatBigNumber */.dp)(bnbBalance, 2);
    var valueAsBn = getValueAsEthersBn(value);
    var showFieldWarning = account && valueAsBn.gt(0) && errorMessage !== null;
    var handleInputChange = function(input) {
        var inputAsBn = getValueAsEthersBn(input);
        if (inputAsBn.eq(0)) {
            setPercent(0);
        } else {
            var inputAsFn = fixednumber/* FixedNumber.from */.xs.from(inputAsBn);
            var maxValueAsFn = fixednumber/* FixedNumber.from */.xs.from(maxBalance);
            var hundredAsFn = fixednumber/* FixedNumber.from */.xs.from(100);
            var percentage = inputAsFn.divUnsafe(maxValueAsFn).mulUnsafe(hundredAsFn);
            var percentageAsFloat = percentage.toUnsafeFloat();
            setPercent(percentageAsFloat > 100 ? 100 : percentageAsFloat);
        }
        setValue(input);
    };
    var handlePercentChange = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var maxValueAsFn = fixednumber/* FixedNumber.from */.xs.from(maxBalance);
            var hundredAsFn = fixednumber/* FixedNumber.from */.xs.from(100);
            var sliderPercentAsFn = fixednumber/* FixedNumber.from */.xs.from(sliderPercent.toFixed(18)).divUnsafe(hundredAsFn);
            var balancePercentage = maxValueAsFn.mulUnsafe(sliderPercentAsFn);
            setValue((0,formatBalance/* formatFixedNumber */.w$)(balancePercentage));
        } else {
            setValue("");
        }
        setPercent(sliderPercent);
    }, [
        maxBalance
    ]);
    // Clear value
    var handleGoBack = function() {
        setValue("");
        setPercent(0);
        onBack();
    };
    var ref8 = getButtonProps(valueAsBn, maxBalance, minBetAmount, isTxPending), key = ref8.key, disabled = ref8.disabled;
    var handleEnterPosition = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var betMethod, callOptions, args, receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        betMethod = position === types/* BetPosition.BULL */.Tu.BULL ? "betBull" : "betBear";
                        callOptions = {
                            gasLimit: 1000000,
                            value: valueAsBn.toString()
                        };
                        args = [
                            epoch
                        ];
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(predictionsContract, betMethod, args, callOptions);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            onSuccess(receipt.transactionHash);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEnterPosition() {
            return _ref.apply(this, arguments);
        };
    }();
    // Warnings
    (0,react.useEffect)(function() {
        var inputAmount = getValueAsEthersBn(value);
        var hasSufficientBalance = inputAmount.gt(0) && inputAmount.lte(maxBalance);
        if (!hasSufficientBalance) {
            setErrorMessage(t("Insufficient FTM balance", {
                symbol: token.symbol
            }));
        } else if (inputAmount.gt(0) && inputAmount.lt(minBetAmount)) {
            setErrorMessage(t("A minimum amount of %num% %token% is required", {
                num: (0,formatBalance/* formatBigNumber */.dp)(minBetAmount),
                token: token.symbol
            }));
        } else {
            setErrorMessage(null);
        }
    }, [
        value,
        maxBalance,
        minBetAmount,
        setErrorMessage,
        t,
        token.symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetPositionHeaderCard, {
                p: "14px 24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "text",
                            scale: "sm",
                            onClick: handleGoBack,
                            px: "0",
                            mr: "8px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                                width: "24px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlexRow, {
                            style: {
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                fontWeight: 700,
                                children: t("Set Position")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionTag, {
                            betPosition: position,
                            onClick: togglePosition,
                            height: "100%",
                            borderRadius: 8,
                            p: "8px 12px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                fontWeight: 700,
                                color: position === types/* BetPosition.BULL */.Tu.BULL ? "textMain" : "white",
                                lineHeight: "140%",
                                children: position === types/* BetPosition.BULL */.Tu.BULL ? t("Up") : t("Down")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                pb: "0px !important",
                pt: "16px !important",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                textAlign: "right",
                                color: "white",
                                children: [
                                    t("Commit"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpusdToken/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: 2,
                                        children: "FTM"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                        value: value,
                        onUserInput: handleInputChange,
                        isWarning: showFieldWarning,
                        inputProps: {
                            disabled: !account || isTxPending
                        },
                        className: !account || isTxPending ? "" : "swiper-no-swiping"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "right",
                        color: "white60",
                        mt: "4px",
                        children: account && t("Balance: %balance%", {
                            balance: balanceDisplay
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                        name: "balance",
                        min: 0,
                        max: 100,
                        value: percent,
                        onValueChanged: handlePercentChange,
                        valueLabel: account ? "".concat(percent.toFixed(percent > 0 ? 1 : 0), "%") : "",
                        step: 0.01,
                        disabled: !account || isTxPending,
                        mb: "15px",
                        className: !account || isTxPending ? "" : "swiper-no-swiping"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "16px",
                        children: [
                            percentShortcuts.map(function(percentShortcut) {
                                var handleClick = function() {
                                    handlePercentChange(percentShortcut);
                                };
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPercentItem, {
                                    variant: "secondary",
                                    onClick: handleClick,
                                    disabled: !account || isTxPending,
                                    className: !account || isTxPending ? "" : "swiper-no-swiping",
                                    children: "".concat(percentShortcut, "%")
                                }, percentShortcut);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPercentItem, {
                                variant: "secondary",
                                onClick: function() {
                                    return handlePercentChange(100);
                                },
                                disabled: !account || isTxPending,
                                className: !account || isTxPending ? "" : "swiper-no-swiping",
                                children: t("100%")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: "16px",
                        children: account ? doesCakeApprovePrediction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                            height: "36px",
                            width: "100%",
                            disabled: disabled,
                            className: disabled ? "" : "swiper-no-swiping",
                            onClick: handleEnterPosition,
                            isLoading: isTxPending,
                            children: t(key, {
                                symbol: token.symbol
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                            height: "36px",
                            width: "100%",
                            className: "swiper-no-swiping",
                            onClick: handleApprove,
                            isLoading: pendingTx,
                            children: !pendingTx ? "Approve" : "Approving"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                            style: {
                                height: "36px",
                                fontWeight: 700
                            },
                            className: "swiper-no-swiping",
                            width: "100%"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        fontSize: "14px",
                        lineHeight: 1,
                        color: "white60",
                        children: t("You won’t be able to remove or change your position once you enter it.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_SetPositionCard = (SetPositionCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/OpenRoundCard.tsx





function OpenRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    OpenRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















// const StyledEnterButton = styled(Button)`
//   font-size: 14px;
//   color: ${(props) => props.textColor || 'white'};
// `
// const StyledDisableEnteredButton = styled(Button)`
//   height: 36px;
//   font-size: 14px;
//   font-weight: 700;
// `
var OpenRoundCard_StyledRoundResultBox = (0,styled_components_browser_esm/* default */.ZP)(RoundResultBox).withConfig({
    componentId: "sc-cc8dff71-0"
})(OpenRoundCard_templateObject());
var OpenRoundCard = function(param) {
    var round = param.round, betAmount = param.betAmount, hasEnteredUp = param.hasEnteredUp, hasEnteredDown = param.hasEnteredDown, bullMultiplier = param.bullMultiplier, bearMultiplier = param.bearMultiplier;
    var ref = (0,react.useState)({
        isSettingPosition: false,
        position: types/* BetPosition.BULL */.Tu.BULL
    }), state = ref[0], setState = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), token = ref1.token, displayedDecimals = ref1.displayedDecimals;
    var lockTimestamp = (round !== null && round !== void 0 ? round : {
        lockTimestamp: null
    }).lockTimestamp;
    var isSettingPosition = state.isSettingPosition, position = state.position;
    var ref2 = (0,react.useState)(false), isBufferPhase = ref2[0], setIsBufferPhase = ref2[1];
    var positionDisplay = (0,react.useMemo)(function() {
        return position === types/* BetPosition.BULL */.Tu.BULL ? t("Up").toUpperCase() : t("Down").toUpperCase();
    }, [
        t,
        position
    ]);
    var positionEnteredText = (0,react.useMemo)(function() {
        return hasEnteredUp ? t("Up").toUpperCase() : hasEnteredDown ? t("Down").toUpperCase() : null;
    }, [
        t,
        hasEnteredUp,
        hasEnteredDown
    ]);
    var positionEnteredIcon = (0,react.useMemo)(function() {
        return hasEnteredUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
            color: "currentColor"
        }) : hasEnteredDown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
            color: "currentColor"
        }) : null;
    }, [
        hasEnteredUp,
        hasEnteredDown
    ]);
    var ref3 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: "".concat((0,Predictions_helpers/* formatBnbv2 */.rc)(betAmount, displayedDecimals), " FTM")
    }), {
        placement: "top"
    }), targetRef = ref3.targetRef, tooltipVisible = ref3.tooltipVisible, tooltip = ref3.tooltip;
    (0,react.useEffect)(function() {
        var secondsToLock = lockTimestamp ? lockTimestamp - getNow() : 0;
        if (secondsToLock > 0) {
            var setIsBufferPhaseTimeout = setTimeout(function() {
                setIsBufferPhase(true);
            }, (secondsToLock - config/* ROUND_BUFFER */.fq) * 1000);
            return function() {
                clearTimeout(setIsBufferPhaseTimeout);
            };
        }
        return undefined;
    }, [
        lockTimestamp
    ]);
    var getHasEnteredPosition = function() {
        if (hasEnteredUp || hasEnteredDown) {
            return false;
        }
        if (round.lockPrice !== null) {
            return false;
        }
        return true;
    };
    var canEnterPosition = getHasEnteredPosition();
    var handleBack = function() {
        return setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                isSettingPosition: false
            });
        });
    };
    var handleSetPosition = function(newPosition) {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                isSettingPosition: true,
                position: newPosition
            });
        });
    };
    var togglePosition = function() {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                position: prevState.position === types/* BetPosition.BULL */.Tu.BULL ? types/* BetPosition.BEAR */.Tu.BEAR : types/* BetPosition.BULL */.Tu.BULL
            });
        });
    };
    var handleSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(hash) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,predictions/* fetchLedgerData */.Ub)({
                                account: account,
                                epochs: [
                                    round.epoch
                                ]
                            }))
                        ];
                    case 1:
                        _state.sent();
                        handleBack();
                        helperToast/* helperToast.success */.U.success(/*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: hash,
                            children: t("%position% position entered", {
                                position: positionDisplay
                            })
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSuccess(hash) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_CardFlip, {
        isFlipped: isSettingPosition,
        height: "500px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                borderBackground: getBorderBackground(theme, "next"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                        status: "next",
                        epoch: round.epoch,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutline/* default */.Z, {
                            color: "textMain",
                            mr: "4px",
                            width: "24px"
                        }),
                        title: t("Next")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                        p: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                betAmount: betAmount,
                                multiplier: bullMultiplier,
                                hasEntered: hasEnteredUp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenRoundCard_StyledRoundResultBox, {
                                isNext: true,
                                isLive: !canEnterPosition,
                                children: canEnterPosition ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount,
                                            mb: "16px"
                                        }),
                                        !canEnterPosition || isBufferPhase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "success",
                                            width: "100%",
                                            onClick: function() {
                                                return handleSetPosition(types/* BetPosition.BULL */.Tu.BULL);
                                            },
                                            mb: "16px",
                                            height: 36,
                                            disabled: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                color: "textPrimary",
                                                children: t("Enter UP")
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "primary",
                                            width: "100%",
                                            onClick: function() {
                                                return handleSetPosition(types/* BetPosition.BULL */.Tu.BULL);
                                            },
                                            mb: "16px",
                                            height: 36,
                                            disabled: !canEnterPosition || isBufferPhase,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                color: "textPrimary",
                                                children: t("Enter UP")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "danger",
                                            width: "100%",
                                            height: 36,
                                            onClick: function() {
                                                return handleSetPosition(types/* BetPosition.BEAR */.Tu.BEAR);
                                            },
                                            disabled: !canEnterPosition || isBufferPhase,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                color: "textPrimary",
                                                children: t("Enter DOWN")
                                            })
                                        })
                                    ]
                                }) : positionEnteredText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: targetRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                disabled: true,
                                                startIcon: positionEnteredIcon,
                                                width: "100%",
                                                mb: "16px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontWeight: 700,
                                                    color: "textPrimary",
                                                    children: t("%position% Entered", {
                                                        position: positionEnteredText
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount
                                        }),
                                        tooltipVisible && tooltip
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                disabled: true,
                                                width: "100%",
                                                mb: "16px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontWeight: 700,
                                                    color: "textPrimary",
                                                    children: t("No position entered")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrizePoolRow, {
                                            totalAmount: round.totalAmount
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                                betAmount: betAmount,
                                multiplier: bearMultiplier,
                                betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                                hasEntered: hasEnteredDown
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_SetPositionCard, {
                onBack: handleBack,
                onSuccess: handleSuccess,
                position: position,
                togglePosition: togglePosition,
                epoch: round.epoch
            })
        ]
    });
};
/* harmony default export */ var RoundCard_OpenRoundCard = (OpenRoundCard);

;// CONCATENATED MODULE: ./src/utils/accurateTimer.ts
var accurateTimer = function(callback) {
    var time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var nextAt;
    var timeout;
    nextAt = new Date().getTime() + time;
    var wrapper = function() {
        nextAt += time;
        timeout = setTimeout(wrapper, nextAt - new Date().getTime());
        callback === null || callback === void 0 ? void 0 : callback();
    };
    var cancel = function() {
        return clearTimeout(timeout);
    };
    timeout = setTimeout(wrapper, nextAt - new Date().getTime());
    return {
        cancel: cancel
    };
};

// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 4 modules
var hooks_src = __webpack_require__(74903);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useCountdown.ts




var getSecondsRemainingToNow = function(timestamp) {
    var now = getNow();
    return Number.isFinite(timestamp) && timestamp > now ? timestamp - now : 0;
};
/**
 * Consider this moving up to the global level
 */ var useCountdown = function(timestamp) {
    var timerCancelRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(function() {
        return getSecondsRemainingToNow(timestamp);
    }), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var ref1 = (0,react.useState)(false), isPaused = ref1[0], setIsPaused = ref1[1];
    var isWindowVisible = (0,hooks_src/* useIsWindowVisible */.yr)();
    var pause = (0,react.useCallback)(function() {
        return setIsPaused(true);
    }, [
        setIsPaused
    ]);
    var unpause = (0,react.useCallback)(function() {
        return setIsPaused(false);
    }, [
        setIsPaused
    ]);
    (0,react.useEffect)(function() {
        var cancel;
        if (!isPaused) {
            var ref = accurateTimer(function() {
                setSecondsRemaining(function(prevSecondsRemaining) {
                    var ref;
                    if (prevSecondsRemaining) {
                        return prevSecondsRemaining - 1;
                    }
                    (ref = timerCancelRef.current) === null || ref === void 0 ? void 0 : ref.call(timerCancelRef);
                    return prevSecondsRemaining;
                });
            }), timerCancel = ref.cancel;
            cancel = timerCancel;
            timerCancelRef.current = timerCancel;
        }
        return function() {
            cancel === null || cancel === void 0 ? void 0 : cancel();
        };
    }, [
        isPaused,
        timestamp,
        setSecondsRemaining
    ]);
    // Pause the timer if the tab becomes inactive to avoid it becoming out of sync
    (0,react.useEffect)(function() {
        if (isWindowVisible) {
            setSecondsRemaining(getSecondsRemainingToNow(timestamp));
            unpause();
        } else {
            pause();
        }
    }, [
        pause,
        unpause,
        timestamp,
        setSecondsRemaining,
        isWindowVisible
    ]);
    return {
        secondsRemaining: secondsRemaining,
        pause: pause,
        unpause: unpause
    };
};
/* harmony default export */ var hooks_useCountdown = (useCountdown);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/SoonRoundCard.tsx

function SoonRoundCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    SoonRoundCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var CountdownWrapper = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-68ca3a1a-0"
})(SoonRoundCard_templateObject());
var SoonRoundCard = function(param) {
    var round = param.round, currentEpoch = param.currentEpoch;
    var intervalSeconds = (0,predictions_hooks/* useGetIntervalSeconds */.m3)();
    var currentRoundCloseTimestamp = (0,predictions_hooks/* useGetCurrentRoundCloseTimestamp */.ds)();
    var secondsRemaining = hooks_useCountdown(currentRoundCloseTimestamp + intervalSeconds * (round.epoch - currentEpoch - 1)).secondsRemaining;
    // const { secondsRemaining } = useCountdown(round.startTimestamp + intervalSeconds + ROUND_BUFFER)
    var countdown = (0,Predictions_helpers/* formatRoundTime */.tw)(secondsRemaining);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        borderBackground: getBorderBackground(theme, "soon"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_CardHeader, {
                status: "soon",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wait/* default */.Z, {
                    mr: "4px",
                    width: "24px"
                }),
                title: t("Later"),
                epoch: round.epoch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        isDisabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundResultBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownWrapper, {
                            textAlign: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: t("Entry starts")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    children: "~ ".concat(countdown)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_MultiplierArrow, {
                        betPosition: types/* BetPosition.BEAR */.Tu.BEAR,
                        isDisabled: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoundCard_SoonRoundCard = (SoonRoundCard);

;// CONCATENATED MODULE: ./src/views/Predictions/components/RoundCard/index.tsx









var RoundCard = function(param) {
    var round = param.round, isActive = param.isActive;
    var epoch = round.epoch, lockPrice = round.lockPrice, closePrice = round.closePrice, totalAmount = round.totalAmount, bullAmount = round.bullAmount, bearAmount = round.bearAmount;
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ledger = (0,predictions_hooks/* useGetBetByEpoch */.n3)(account, epoch);
    var hasEntered = ledger ? ledger.amount.gt(0) : false;
    var hasEnteredUp = hasEntered && ledger.position === types/* BetPosition.BULL */.Tu.BULL;
    var hasEnteredDown = hasEntered && ledger.position === types/* BetPosition.BEAR */.Tu.BEAR;
    var hasClaimedUp = hasEntered && ledger.claimed && ledger.position === types/* BetPosition.BULL */.Tu.BULL;
    var hasClaimedDown = hasEntered && ledger.claimed && ledger.position === types/* BetPosition.BEAR */.Tu.BEAR;
    // Fake future rounds
    if (epoch > currentEpoch) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_SoonRoundCard, {
            round: round,
            currentEpoch: currentEpoch
        });
    }
    var bullMultiplier = (0,Predictions_helpers/* getMultiplierV2 */.jw)(totalAmount, bullAmount);
    var bearMultiplier = (0,Predictions_helpers/* getMultiplierV2 */.jw)(totalAmount, bearAmount);
    var formattedBullMultiplier = bullMultiplier.toUnsafeFloat().toFixed(bullMultiplier.isZero() ? 0 : 2);
    var formattedBearMultiplier = bearMultiplier.toUnsafeFloat().toFixed(bearMultiplier.isZero() ? 0 : 2);
    // Next (open) round
    if (epoch === currentEpoch && lockPrice === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_OpenRoundCard, {
            round: round,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
            bullMultiplier: formattedBullMultiplier,
            bearMultiplier: formattedBearMultiplier
        });
    }
    // Live round
    if (closePrice === null && epoch === currentEpoch - 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_LiveRoundCard, {
            betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
            hasEnteredDown: hasEnteredDown,
            hasEnteredUp: hasEnteredUp,
            round: round,
            bullMultiplier: formattedBullMultiplier,
            bearMultiplier: formattedBearMultiplier
        });
    }
    // Past rounds
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCard_ExpiredRoundCard, {
        isActive: isActive,
        round: round,
        hasEnteredDown: hasEnteredDown,
        hasEnteredUp: hasEnteredUp,
        hasClaimedDown: hasClaimedDown,
        hasClaimedUp: hasClaimedUp,
        betAmount: ledger === null || ledger === void 0 ? void 0 : ledger.amount,
        bullMultiplier: formattedBullMultiplier,
        bearMultiplier: formattedBearMultiplier
    });
};
/* harmony default export */ var components_RoundCard = (RoundCard);

// EXTERNAL MODULE: ./src/views/Predictions/hooks/useSwiper.ts
var useSwiper = __webpack_require__(82961);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(87613);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useOnNextRound.ts






/**
 * Hooks for actions to be performed when the round changes
 */ var useOnNextRound = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var ref = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref.currentEpoch, rounds = ref.rounds;
    var roundsEpochsString = JSON.stringify(Object.keys(rounds));
    var previousEpoch = (0,hooks_src/* usePreviousValue */.zP)(currentEpoch);
    var previousRoundsEpochsString = (0,hooks_src/* usePreviousValue */.zP)(roundsEpochsString);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        if (swiper && currentEpoch && previousEpoch && (currentEpoch !== previousEpoch || roundsEpochsString !== previousRoundsEpochsString)) {
            var currentEpochIndex = rounds.findIndex(function(round) {
                return round.epoch === currentEpoch;
            });
            // Slide to the current LIVE round which is always the one before the current round
            if (currentEpoch !== previousEpoch) {
                swiper.slideTo(currentEpochIndex - 1);
            } else if (!swiper.isBeginning && !swiper.isEnd) {
                swiper.slideTo(swiper.activeIndex - 1, 0);
            }
        }
    }, [
        previousEpoch,
        currentEpoch,
        previousRoundsEpochsString,
        roundsEpochsString,
        rounds,
        swiper,
        account,
        dispatch
    ]);
};
/* harmony default export */ var hooks_useOnNextRound = (useOnNextRound);

;// CONCATENATED MODULE: ./src/views/Predictions/hooks/useOnViewChange.ts



/**
 * Hooks for actions to be performed when the view changes (mobile)
 */ var useOnViewChange = function(liveSwiperIndex, view) {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var prevView = (0,hooks_src/* usePreviousValue */.zP)(view);
    (0,react.useEffect)(function() {
        if (swiper && view !== prevView && swiper.activeIndex !== liveSwiperIndex) {
            swiper.slideTo(liveSwiperIndex, 0.1);
        }
    }, [
        swiper,
        prevView,
        view,
        liveSwiperIndex
    ]);
};
/* harmony default export */ var hooks_useOnViewChange = (useOnViewChange);

;// CONCATENATED MODULE: ./src/views/Predictions/Positions.tsx

function Positions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -41px;\n\n  .swiper-wrapper {\n    align-items: center;\n    display: flex;\n  }\n\n  .swiper-slide {\n    width: 320px;\n  }\n\n  @media screen and (max-width: 767px) {\n    margin-top: -32px;\n  }\n"
    ]);
    Positions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Keyboard */.N1,
    swiper_esm/* Mousewheel */.Gk,
    swiper_esm/* FreeMode */.Rv
]);
var StyledSwiper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c489ec46-0"
})(Positions_templateObject());
var Positions = function(param) {
    var view = param.view;
    var ref = (0,useSwiper/* default */.Z)(), setSwiper = ref.setSwiper, swiper = ref.swiper;
    var ref1 = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref1.currentEpoch, rounds = ref1.rounds;
    var previousEpoch = currentEpoch > 0 ? currentEpoch - 1 : currentEpoch;
    var swiperIndex = rounds.findIndex(function(round) {
        return round.epoch === previousEpoch;
    });
    hooks_useOnNextRound();
    hooks_useOnViewChange(swiperIndex, view);
    (0,react.useEffect)(function() {
        var ref;
        var handleChartDotClick = function() {
            setIsChangeTransition(true);
            delay_default()(function() {
                return setIsChangeTransition(false);
            }, 3000);
        };
        swiper === null || swiper === void 0 ? void 0 : (ref = swiper.el) === null || ref === void 0 ? void 0 : ref.addEventListener(Predictions_helpers/* CHART_DOT_CLICK_EVENT */.o4, handleChartDotClick);
        return function() {
            var ref;
            swiper === null || swiper === void 0 ? void 0 : (ref = swiper.el) === null || ref === void 0 ? void 0 : ref.removeEventListener(Predictions_helpers/* CHART_DOT_CLICK_EVENT */.o4, handleChartDotClick);
        };
    }, [
        swiper === null || swiper === void 0 ? void 0 : swiper.el
    ]);
    var ref2 = (0,react.useState)(false), isChangeTransition = ref2[0], setIsChangeTransition = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            initialSlide: swiperIndex,
            onSwiper: setSwiper,
            spaceBetween: 16,
            slidesPerView: "auto",
            onBeforeDestroy: function() {
                return setSwiper(null);
            },
            freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.25,
                momentumVelocityRatio: 0.5
            },
            centeredSlides: true,
            mousewheel: true,
            keyboard: true,
            resizeObserver: true,
            children: rounds.map(function(round) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: function(param) {
                        var isActive = param.isActive;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoundCard, {
                            round: round,
                            isActive: isChangeTransition && isActive
                        });
                    }
                }, round.epoch);
            })
        })
    });
};
/* harmony default export */ var Predictions_Positions = (Positions);

;// CONCATENATED MODULE: ./src/views/Predictions/components/LoadingSection.tsx


function LoadingSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
        height: "420px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    });
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(95160);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Shield.tsx
var Shield = __webpack_require__(84920);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PocketWatch.tsx
var PocketWatch = __webpack_require__(88373);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
;// CONCATENATED MODULE: ./src/views/Predictions/components/LabelPrice.tsx





var LabelPrice = function(param) {
    var price = param.price;
    var priceAsNumber = (0,react.useMemo)(function() {
        return parseFloat((0,formatBalance/* formatBigNumberToFixed */.U1)(price, 4, 8));
    }, [
        price
    ]);
    if (!Number.isFinite(priceAsNumber)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        start: 0,
        preserveValue: true,
        delay: 0,
        end: priceAsNumber,
        prefix: "$",
        decimals: 4,
        duration: 1,
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "16px",
                fontWeight: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: countUpRef
                })
            });
        }
    });
};
/* harmony default export */ var components_LabelPrice = (/*#__PURE__*/(0,react.memo)(LabelPrice));

;// CONCATENATED MODULE: ./src/views/Predictions/components/Label.tsx

function Label_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 50px;\n  background-color: ",
        ";\n  border-radius: 8px;\n  padding: 5.5px 16px 5.5px 16px;\n  gap: 8px;\n  border: 1px solid ",
        ";\n\n  width: fit-content;\n  margin-left: auto;\n\n  ",
        " {\n    gap: unset;\n    width: fit-content;\n  }\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    margin-left: 0;\n  }\n"
    ]);
    Label_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Label_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 30;\n\n  & > svg {\n    height: 32px;\n    width: 32px;\n  }\n"
    ]);
    Label_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Label_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n  color: ",
        ";\n  line-height: normal;\n"
    ]);
    Label_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Label_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 140%;\n\n  /* font-size: 9px;\n  line-height: 21px;\n\n  ",
        " {\n    font-size: 16px;\n  }\n\n  ",
        " {\n    font-size: 20px;\n    line-height: 22px;\n  } */\n"
    ]);
    Label_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Label_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    color: ",
        ";\n    text-wrap: nowrap;\n    /* width: 100px; */\n  }\n\n  /* ",
        " {\n    > span {\n      display: none;\n    }\n  } */\n  @media (max-width: 769px) {\n    span {\n      display: none;\n    }\n  }\n"
    ]);
    Label_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Label_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%{\n    opacity:0;\n  }\n  20%{\n    opacity:1;\n  }\n  30%{\n    transform: translateX(5px);\n  }\n  40%{\n    transform: translateX(0px);\n  }\n  50%{\n    transform: translateX(5px);\n  }\n  60%{\n    transform: translateX(5px);\n  }\n  100%{\n    opacity:1;\n  }\n"
    ]);
    Label_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Label_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -5px;\n  left: 55px;\n  border-radius: 16px;\n  padding: 16px;\n  background: ",
        ";\n  box-shadow: ",
        ";\n  white-space: nowrap;\n  opacity: 0;\n  z-index: 100;\n  animation: ",
        " 3s forwards ease-in-out;\n  ",
        ",svg {\n    color: ",
        ";\n  }\n  ",
        " {\n    top: -10px;\n    left: 81px;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 21px;\n    left: -6px;\n    width: 15px;\n    height: 15px;\n    border-radius: 3px;\n    background: ",
        ";\n    transform: rotate(45deg);\n  }\n"
    ]);
    Label_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Label_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 8px;\n  position: relative;\n  z-index: 1;\n  box-shadow: ",
        ";\n  /* align-items: ",
        "; */\n  border-radius: ",
        ";\n  overflow: initial;\n  justify-content: space-between;\n  flex: 1;\n\n  ",
        " {\n    /* align-items: flex-start; */\n    border-radius: ",
        ";\n    /* padding: ",
        "; */\n    transition: 0.3s background-color ease-in-out;\n    will-change: background-color;\n  }\n"
    ]);
    Label_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 32px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}














var Label_TOKEN = "FTM";
var TimerBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-0"
})(Label_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
});
var Token = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-1"
})(Label_templateObject1());
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-2"
})(Label_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ClosingTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-3"
})(Label_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Interval = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-4"
})(Label_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white60;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
});
var tooltipAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Label_templateObject5());
var Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9f4cd40-5"
})(Label_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, tooltipAnimation, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var Label = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-6"
})(Label_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.shadows.level1;
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "flex-end" : "center";
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "8px 8px 8px 24px" : "8px 8px 24px 8px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.radii.medium;
}, function(param) {
    var dir = param.dir;
    return dir === "right" ? "8px 40px 8px 8px" : "5.5px 16px 5.5px 16px";
});
var StyledOpusdTokenIcon = (0,styled_components_browser_esm/* default */.ZP)(OpusdToken/* default */.Z).withConfig({
    componentId: "sc-e9f4cd40-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
});
var PricePairLabel = function() {
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var router = (0,next_router.useRouter)();
    var price = (0,usePollOraclePrice/* default */.Z)().price;
    var ref = (0,react.useState)(function() {
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* PREDICTION_TOOLTIP_DISMISS_KEY */.bF)) return true;
        return false;
    }), dismissTooltip = ref[0], setDismissTooltip = ref[1];
    var onDismissTooltip = (0,react.useCallback)(function() {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(constants/* PREDICTION_TOOLTIP_DISMISS_KEY */.bF, "1");
        setDismissTooltip(true);
    }, []);
    var onTokenSwitch = (0,react.useCallback)(function() {
        if (router.query.token === types/* PredictionSupportedSymbol.CAKE */.ru.CAKE) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else if (router.query.token === undefined && token.symbol === types/* PredictionSupportedSymbol.CAKE */.ru.CAKE) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else if (router.query.token === undefined && token.symbol === types/* PredictionSupportedSymbol.BNB */.ru.BNB) {
            router.query.token = types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
        } else if (token.symbol === undefined && router.query.token === undefined) {
            router.query.token = types/* PredictionSupportedSymbol.BNB */.ru.BNB;
        } else {
            router.query.token = types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
        }
        if (!dismissTooltip) onDismissTooltip();
        router.replace(router, undefined, {
            scroll: false
        });
    }, [
        router,
        token,
        dismissTooltip,
        onDismissTooltip
    ]);
    // return null
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            pl: [
                "0",
                "0",
                "0",
                "0",
                "0"
            ],
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOpusdTokenIcon, {
                    width: "32px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                    alignItems: "center",
                    backgroundOpacity: !dismissTooltip,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                            bold: true,
                            textTransform: "uppercase",
                            children: [
                                Label_TOKEN,
                                "/USD"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LabelPrice, {
                            price: price
                        })
                    ]
                })
            ]
        })
    });
};
var TimerLabel = function(param) {
    var interval = param.interval, unit = param.unit;
    var currentRoundCloseTimestamp = (0,predictions_hooks/* useGetCurrentRoundCloseTimestamp */.ds)();
    var secondsRemaining = hooks_useCountdown(currentRoundCloseTimestamp).secondsRemaining;
    var countdown = (0,Predictions_helpers/* formatRoundTime */.tw)(secondsRemaining);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // console.log('test123', currentRoundCloseTimestamp, secondsRemaining, countdown)
    if (!currentRoundCloseTimestamp) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimerBox, {
        pr: "24px",
        display: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Token, {
                display: "flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PocketWatch/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                dir: "left",
                alignItems: "flex-start",
                flexDirection: "column",
                children: [
                    secondsRemaining !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        bold: true,
                        color: "secondary",
                        children: countdown
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClosingTitle, {
                        bold: true,
                        color: "secondary",
                        children: t("Closing")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Interval, {
                        fontSize: "12px",
                        children: "".concat(interval).concat(t(unit), " per round")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BunnyCards.tsx
var BunnyCards = __webpack_require__(60380);
;// CONCATENATED MODULE: ./src/views/Predictions/components/PrevNextNav.tsx

function PrevNextNav_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: none;\n  justify-content: space-between;\n  overflow: initial;\n  position: relative;\n  height: 40px;\n  width: 184px;\n  padding: 4px;\n\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  /* background-color: ",
        "; */\n\n  background-color: ",
        ";\n\n  .Button-Arrow {\n    &:hover {\n      opacity: 1;\n    }\n\n    &.next {\n      svg {\n        rotate: 180deg;\n      }\n    }\n  }\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    PrevNextNav_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrevNextNav_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 50%;\n  margin-left: -32px;\n  position: absolute;\n"
    ]);
    PrevNextNav_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledPrevNextNav = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-21f85d22-0"
})(PrevNextNav_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.level1;
}, function(param) {
    var theme = param.theme;
    return theme.radii.full;
}, function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21f85d22-1"
})(PrevNextNav_templateObject1());
var PrevNextNav = function() {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var ref = (0,predictions_hooks/* useGetSortedRoundsCurrentEpoch */.Aq)(), currentEpoch = ref.currentEpoch, rounds = ref.rounds;
    var handlePrevSlide = function() {
        swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    var handleNextSlide = function() {
        swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    var handleSlideToLive = function() {
        if (swiper) {
            var currentEpochIndex = rounds.findIndex(function(round) {
                return round.epoch === currentEpoch;
            });
            swiper.slideTo(currentEpochIndex - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrevNextNav, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: "Button-Arrow",
                variant: "text",
                scale: "sm",
                onClick: handlePrevSlide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                    color: "white",
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                onClick: handleSlideToLive,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyCards/* default */.Z, {
                    width: "64px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: "Button-Arrow next",
                variant: "text",
                scale: "sm",
                onClick: handleNextSlide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                    color: "white",
                    width: "24px"
                })
            })
        ]
    });
};
/* harmony default export */ var components_PrevNextNav = (PrevNextNav);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var Icons_History = __webpack_require__(66806);
;// CONCATENATED MODULE: ./src/views/Predictions/components/HistoryButton.tsx

function HistoryButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  box-shadow: none;\n  height: 100%;\n"
    ]);
    HistoryButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-cc0ebc82-0"
})(HistoryButton_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
});
var HistoryButton = function() {
    var isFetchingHistory = (0,predictions_hooks/* useGetIsFetchingHistory */.dW)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleClick = function() {
        dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
        id: "prediction-history-button",
        variant: "subtle",
        onClick: handleClick,
        isLoading: isFetchingHistory,
        disabled: !account,
        children: isFetchingHistory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "white"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_History/* default */.Z, {
            width: "24px",
            color: "white"
        })
    });
};
/* harmony default export */ var components_HistoryButton = (HistoryButton);

;// CONCATENATED MODULE: ./src/views/Predictions/components/Menu.tsx

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  min-width: 324px;\n\n  /* ",
        " {\n    width: 270px;\n  } */\n"
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Menu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  height: 50px;\n  width: 100%;\n  max-width: 324px;\n\n  @media (max-width: 739px) {\n    max-width: unset;\n  }\n"
    ]);
    Menu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Menu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 767px) {\n    margin-left: 0;\n    width: 100%;\n  }\n"
    ]);
    Menu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Menu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  margin: 0 2px 0 10px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n\n  ",
        " {\n    order: 2;\n    margin: 0 0 0 10px;\n  }\n"
    ]);
    Menu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Menu_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  flex: 1;\n  /* width: 100px; */\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    Menu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Menu_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  order: 2;\n  margin: 0 0 0 10px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n\n  ",
        " {\n    order: 3;\n  }\n"
    ]);
    Menu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Menu_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    margin-left: 10px;\n  }\n"
    ]);
    Menu_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Menu_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 48px;\n  padding-bottom: 48px;\n\n  @media (max-width: 739px) {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n    justify-content: space-between;\n    gap: 16px;\n  }\n"
    ]);
    Menu_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Menu_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 739px) {\n    display: none;\n  }\n"
    ]);
    Menu_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}









var SetCol = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e961b8a0-0"
})(Menu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PriceCol = (0,styled_components_browser_esm/* default */.ZP)(SetCol).withConfig({
    componentId: "sc-e961b8a0-1"
})(Menu_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
});
var TimeWrap = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e961b8a0-2"
})(Menu_templateObject2());
var HelpButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e961b8a0-3"
})(Menu_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TimerLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e961b8a0-4"
})(Menu_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LeaderboardButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e961b8a0-5"
})(Menu_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e961b8a0-6"
})(Menu_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var StyledTopMenu = (0,styled_components_browser_esm/* default */.ZP)(components_FlexRow).withConfig({
    componentId: "sc-e961b8a0-7"
})(Menu_templateObject7());
var StyledPrevNextNavWrapper = (0,styled_components_browser_esm/* default */.ZP)(components_FlexRow).withConfig({
    componentId: "sc-e961b8a0-8"
})(Menu_templateObject8());
var Menu = function() {
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopMenu, {
        alignItems: "center",
        p: "16px",
        width: "100%",
        children: [
            status === types/* PredictionStatus.LIVE */.Gw.LIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceCol, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePairLabel, {})
            }),
            status === types/* PredictionStatus.LIVE */.Gw.LIVE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrevNextNavWrapper, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PrevNextNav, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SetCol, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeWrap, {
                            alignItems: "stretch",
                            justifyContent: "flex-end",
                            height: "50px",
                            width: "fit-content",
                            ml: "auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerLabelWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerLabel, {
                                        interval: "5",
                                        unit: "m"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "text",
                                        as: "a",
                                        href: "https://docs.mummy.finance/prediction",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        width: "50px",
                                        height: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                            width: "24px",
                                            color: "white"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        as: "a",
                                        href: "prediction/leaderboard",
                                        variant: "text",
                                        width: "50px",
                                        height: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shield/* default */.Z, {
                                            color: "white"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                                    style: {
                                        order: 4
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HistoryButton, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Menu = (Menu);

;// CONCATENATED MODULE: ./src/views/Predictions/Desktop.tsx

function Desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 24px;\n  left: 32px;\n  position: absolute;\n  display: none;\n  background-color: ",
        ";\n  border-radius: 24px 24px 0 0;\n  z-index: 50;\n  ",
        " {\n    display: inline-flex;\n  }\n"
    ]);
    Desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: absolute;\n  right: 20px;\n  bottom: 100%;\n\n  z-index: 9;\n\n  cursor: pointer;\n"
    ]);
    Desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Desktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 24px 0;\n  flex: 1;\n  overflow: hidden;\n"
    ]);
    Desktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Desktop_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  background: ",
        ";\n"
    ]);
    Desktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Desktop_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  overflow: hidden;\n  transition: width 200ms ease-in-out;\n  background: ",
        ";\n  padding-bottom: ",
        ";\n  width: ",
        ";\n"
    ]);
    Desktop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Desktop_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: flex;\n    /* height: calc(100vh - 100px); */\n    height: 100vh;\n    /* height: calc(1const GRID_TEMPLATE_ROW = '1.4fr 24px 0.6fr'00vh + 100px); */\n  }\n"
    ]);
    Desktop_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Desktop_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  max-width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-image: url('/images/color_bg.png'), linear-gradient(180deg, #04050b 0%, #01021a 100%);\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin-top: 62px;\n\n  /* background-image: \"url('src/views/Predictions/top_bg.svg')\"; */\n\n  & > div {\n    flex: 1;\n    overflow: hidden;\n  }\n"
    ]);
    Desktop_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Desktop_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  cursor: ",
        ";\n  height: 24px;\n  position: relative;\n\n  &:before {\n    background-color: ",
        ";\n    border-radius: 8px;\n    content: '';\n    height: 4px;\n    left: 50%;\n    margin-left: -32px;\n    position: absolute;\n    top: 10px;\n    width: 64px;\n  }\n"
    ]);
    Desktop_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






















// import { BG_TOP } from '../../../packages/uikit/src/components/Svg'
// import top_bg from './top_bg.svg'
var ChainlinkChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2077), __webpack_require__.e(9782), __webpack_require__.e(265), __webpack_require__.e(9386)]).then(__webpack_require__.bind(__webpack_require__, 9386));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9386)
            ];
        }
    },
    ssr: false
});
// The value to set the chart when the user clicks the chart tab at the bottom
// const GRID_TEMPLATE_ROW = '1.2fr 24px .8fr'
var GRID_TEMPLATE_ROW = "1.4fr 24px 0.6fr";
var ExpandButtonGroup = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-20965d7a-0"
})(Desktop_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.darkGray;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PowerLinkStyle = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-20965d7a-1"
})(Desktop_templateObject1());
var SplitWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-2"
})(Desktop_templateObject2());
var ChartPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-3"
})(Desktop_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var HistoryPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-4"
})(Desktop_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var isChartPaneOpen = param.isChartPaneOpen;
    return isChartPaneOpen ? 0 : "24px";
}, function(param) {
    var isHistoryPaneOpen = param.isHistoryPaneOpen;
    return isHistoryPaneOpen ? "440px" : 0;
});
var StyledDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-5"
})(Desktop_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PositionPane = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-6"
})(Desktop_templateObject6());
var Gutter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20965d7a-7"
})(Desktop_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var isChartPaneOpen = param.isChartPaneOpen;
    return isChartPaneOpen ? "row-resize" : "pointer";
}, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var Desktop_TOKEN = "FTM";
var Desktop = function() {
    var splitWrapperRef = (0,react.useRef)();
    var chartRef = (0,react.useRef)();
    var gutterRef = (0,react.useRef)();
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    var openChartPane = function() {
        splitWrapperRef.current.style.transition = "grid-template-rows 150ms";
        splitWrapperRef.current.style.gridTemplateRows = GRID_TEMPLATE_ROW;
        // Purely comedic: We only want to animate if we are clicking the open chart button
        // If we keep the transition on the resizing becomes very choppy
        delay_default()(function() {
            splitWrapperRef.current.style.transition = "";
        }, 150);
        dispatch((0,predictions/* setChartPaneState */.nQ)(true));
    };
    var splitInstance = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var height = chartRef.current.getBoundingClientRect().height;
        if (height > 0 && !isChartPaneOpen) {
            dispatch((0,predictions/* setChartPaneState */.nQ)(true));
        }
    }, [
        isChartPaneOpen,
        dispatch
    ]);
    // unmount
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,predictions/* setChartPaneState */.nQ)(false));
        };
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var threshold = 100;
        var handleDrag = debounce_default()(function() {
            var height = chartRef.current.getBoundingClientRect().height;
            // If the height of the chart pane goes below the "snapOffset" threshold mark the chart pane as closed
            dispatch((0,predictions/* setChartPaneState */.nQ)(height > threshold));
        }, 50);
        if (isChartPaneOpen && !splitInstance.current) {
            splitInstance.current = (0,split_grid/* default */.Z)({
                dragInterval: 1,
                snapOffset: threshold,
                onDrag: handleDrag,
                rowGutters: [
                    {
                        track: 1,
                        element: gutterRef.current
                    }, 
                ]
            });
        } else if (!isChartPaneOpen && splitInstance.current) {
            var ref;
            (ref = splitInstance.current) === null || ref === void 0 ? void 0 : ref.destroy();
            splitInstance.current = undefined;
        }
        return function() {
            var ref;
            (ref = splitInstance.current) === null || ref === void 0 ? void 0 : ref.destroy();
            splitInstance.current = undefined;
        };
    }, [
        gutterRef,
        chartRef,
        dispatch,
        isChartPaneOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktop, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SplitWrapper, {
                    ref: splitWrapperRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PositionPane, {
                            children: [
                                status === types/* PredictionStatus.ERROR */.Gw.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_ErrorNotification, {}),
                                status === types/* PredictionStatus.PAUSED */.Gw.PAUSED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_PauseNotification, {}),
                                [
                                    types/* PredictionStatus.INITIAL */.Gw.INITIAL,
                                    types/* PredictionStatus.LIVE */.Gw.LIVE
                                ].includes(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {}),
                                        status === types/* PredictionStatus.LIVE */.Gw.LIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Positions, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSection, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gutter, {
                            ref: gutterRef,
                            isChartPaneOpen: isChartPaneOpen,
                            onClick: function() {
                                openChartPane();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerLinkStyle, {
                                    hiddenIcon: true,
                                    href: "https://chain.link/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerByChainLink/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandButtonGroup, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                                            height: "42px",
                                            as: Button/* default */.Z,
                                            style: {
                                                whiteSpace: "nowrap",
                                                alignItems: "center"
                                            },
                                            isActive: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView,
                                            onMouseDown: function(e) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.TradingView */.RU.TradingView));
                                            },
                                            children: [
                                                chartView === types/* PredictionsChartView.TradingView */.RU.TradingView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                                    mr: "10px"
                                                }),
                                                " TradingView ",
                                                t("Chart")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                                            as: Button/* default */.Z,
                                            height: "42px",
                                            style: {
                                                whiteSpace: "nowrap",
                                                alignItems: "center"
                                            },
                                            isActive: chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink,
                                            onMouseDown: function(e) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.Chainlink */.RU.Chainlink));
                                            },
                                            children: [
                                                chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                                    mr: "10px"
                                                }),
                                                " Chainlink ",
                                                t("Chart")
                                            ]
                                        })
                                    ]
                                }),
                                isChartPaneOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartbyLabel_ChartByLabel, {
                                    justifyContent: "flex-end",
                                    symbol: "".concat(Desktop_TOKEN, "/USD"),
                                    by: chartView,
                                    linkProps: {
                                        onMouseDown: function(e) {
                                            window.open(chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? "https://www.tradingview.com/chart/?symbol=BINANCE%3A".concat(Desktop_TOKEN, "USD") : "https://chain.link/data-feeds", "_blank", "noopener noreferrer");
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                    },
                                    link: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? "https://www.tradingview.com/chart/?symbol=BINANCE%3A".concat(Desktop_TOKEN, "USD") : "https://chain.link/data-feeds"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartPane, {
                            ref: chartRef,
                            children: isChartPaneOpen && (chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_components_TradingView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainlinkChart, {}))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryPane, {
                    isHistoryPaneOpen: isHistoryPaneOpen,
                    isChartPaneOpen: isChartPaneOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_History, {})
                })
            ]
        })
    });
};
/* harmony default export */ var Predictions_Desktop = (/*#__PURE__*/(0,react.memo)(Desktop));

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Predictions/hooks/usePollPredictions.ts






var POLL_TIME_IN_SECONDS = 10;
var usePollPredictions = function() {
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    (0,swr_dist/* default */.ZP)(status !== types/* PredictionStatus.INITIAL */.Gw.INITIAL ? [
        "predictions",
        account
    ] : null, function() {
        return dispatch((0,predictions/* fetchPredictionData */.S9)(account));
    }, {
        refreshInterval: POLL_TIME_IN_SECONDS * 1000,
        refreshWhenHidden: true,
        refreshWhenOffline: true
    });
};
/* harmony default export */ var hooks_usePollPredictions = (usePollPredictions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Cards.tsx
var Cards = __webpack_require__(87907);
;// CONCATENATED MODULE: ./src/views/Predictions/components/MobileMenu.tsx

function MobileMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n"
    ]);
    MobileMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        " !important;\n"
    ]);
    MobileMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  text-align: center;\n"
    ]);
    MobileMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MobileMenu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  display: flex;\n  flex: none;\n  height: 64px;\n\n  padding: 16px;\n  /* margin-bottom: 120px; */\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    MobileMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var ButtonNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cc8d843-0"
})(MobileMenu_templateObject());
var MobileMenu_StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-3cc8d843-1"
})(MobileMenu_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var TabNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cc8d843-2"
})(MobileMenu_templateObject2());
var StyledMobileMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cc8d843-3"
})(MobileMenu_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var getActiveIndex = function(isHistoryOpen, isChartOpen) {
    if (isHistoryOpen) {
        return 2;
    }
    if (isChartOpen) {
        return 1;
    }
    return 0;
};
var MobileMenu = function() {
    var swiper = (0,useSwiper/* default */.Z)().swiper;
    var isHistoryOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    var activeIndex = getActiveIndex(isHistoryOpen, isChartOpen);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var handleItemClick = function(index) {
        switch(index){
            case 2:
                dispatch((0,predictions/* setHistoryPaneState */.vR)(true));
                break;
            case 1:
                dispatch((0,predictions/* setChartPaneState */.nQ)(true));
                dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
                break;
            case 0:
            default:
                dispatch((0,predictions/* setHistoryPaneState */.vR)(false));
                dispatch((0,predictions/* setChartPaneState */.nQ)(false));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileMenu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonNav, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu_StyledIconButton, {
                    onClick: function() {
                        return swiper.slidePrev();
                    },
                    disabled: status !== types/* PredictionStatus.LIVE */.Gw.LIVE,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        width: "24px",
                        color: "white"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabNav, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                    activeIndex: activeIndex,
                    scale: "sm",
                    variant: "primary",
                    onItemClick: handleItemClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards/* default */.Z, {
                                color: "currentColor"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                color: "currentColor"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                            disabled: !account,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_History/* default */.Z, {
                                color: "currentColor"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonNav, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu_StyledIconButton, {
                    onClick: function() {
                        return swiper.slideNext();
                    },
                    disabled: status !== types/* PredictionStatus.LIVE */.Gw.LIVE,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                        width: "24px",
                        color: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/views/Predictions/MobileChart.tsx

function MobileChart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n"
    ]);
    MobileChart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileChart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 100%;\n  background-color: ",
        ";\n"
    ]);
    MobileChart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileChart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  height: 100%;\n  @media only screen and (max-width: 575px) and (max-height: 739px) {\n    height: 100vh;\n  }\n"
    ]);
    MobileChart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var MobileChart_ChainlinkChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2077), __webpack_require__.e(9782), __webpack_require__.e(265), __webpack_require__.e(9386)]).then(__webpack_require__.bind(__webpack_require__, 9386));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9386)
            ];
        }
    },
    ssr: false
});
var MenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d29f7c15-0"
})(MobileChart_templateObject());
var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d29f7c15-1"
})(MobileChart_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.card.background;
});
var MobileChartWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d29f7c15-2"
})(MobileChart_templateObject2());
var MobileChart = function() {
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileChartWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "min-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggleGroup */._, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                            isActive: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView,
                            onClick: function() {
                                return dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.TradingView */.RU.TradingView));
                            },
                            children: [
                                "TradingView ",
                                t("Chart")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToggle/* TabToggle */.o, {
                            isActive: chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink,
                            onClick: function() {
                                return dispatch((0,predictions/* setChartView */.bq)(types/* PredictionsChartView.Chainlink */.RU.Chainlink));
                            },
                            children: [
                                "Chainlink ",
                                t("Chart")
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartWrapper, {
                children: chartView === types/* PredictionsChartView.TradingView */.RU.TradingView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_components_TradingView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileChart_ChainlinkChart, {
                    pt: "8px",
                    isMobile: true
                })
            })
        ]
    });
};
/* harmony default export */ var Predictions_MobileChart = (MobileChart);

;// CONCATENATED MODULE: ./src/views/Predictions/types.ts
var PageView;
(function(PageView) {
    PageView["POSITIONS"] = "positions";
    PageView["HISTORY"] = "history";
    PageView["CHART"] = "chart";
})(PageView || (PageView = {}));

;// CONCATENATED MODULE: ./src/views/Predictions/Mobile.tsx

function Mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  /* height: 100vh; */\n  /* height: 100vh; */\n  max-height: 100%;\n  /* padding-bottom: 60px; */\n\n  ",
        " {\n    display: none;\n  }\n\n  .wrapper-content {\n    margin-top: 0px;\n  }\n\n  @media screen and (max-width: 991px) {\n    justify-content: flex-start;\n    .wrapper-content {\n      /* margin-top: 80px; */\n    }\n    .flex-container {\n      justify-content: flex-start;\n      .wrapper-content {\n        /* margin-top: 80px; */\n      }\n    }\n    .styled-mobile-box {\n      height: 80vh;\n      min-height: 564px;\n      /* flex: 1; */\n      margin-top: 56px;\n    }\n  }\n"
    ]);
    Mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 16px;\n  width: 100%;\n"
    ]);
    Mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var StyledMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90c76d9b-0"
})(Mobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var Mobile_PowerLinkStyle = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-90c76d9b-1"
})(Mobile_templateObject1());
var getView = function(isHistoryPaneOpen, isChartPaneOpen) {
    if (isHistoryPaneOpen) {
        return PageView.HISTORY;
    }
    if (isChartPaneOpen) {
        return PageView.CHART;
    }
    return PageView.POSITIONS;
};
var Mobile = function() {
    var isHistoryPaneOpen = (0,predictions_hooks/* useIsHistoryPaneOpen */.e)();
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var view = getView(isHistoryPaneOpen, isChartPaneOpen);
    var status = (0,predictions_hooks/* useGetPredictionsStatus */.hU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobile, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "styled-mobile-box",
                children: [
                    view === PageView.POSITIONS && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        minHeight: "100%",
                        className: "flex-container",
                        children: [
                            status === types/* PredictionStatus.ERROR */.Gw.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_ErrorNotification, {}),
                            status === types/* PredictionStatus.PAUSED */.Gw.PAUSED && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_PauseNotification, {}),
                            [
                                types/* PredictionStatus.INITIAL */.Gw.INITIAL,
                                types/* PredictionStatus.LIVE */.Gw.LIVE
                            ].includes(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "wrapper-content",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {}),
                                    status === types/* PredictionStatus.LIVE */.Gw.LIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Positions, {
                                        view: view
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSection, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_PowerLinkStyle, {
                                        hiddenIcon: true,
                                        href: "https://chain.link/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerByChainLink/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    view === PageView.CHART && /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_MobileChart, {}),
                    view === PageView.HISTORY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_History, {})
                ]
            }),
            status === types/* PredictionStatus.PAUSED */.Gw.PAUSED ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileMenu, {})
        ]
    });
};
/* harmony default export */ var Predictions_Mobile = (/*#__PURE__*/(0,react.memo)(Mobile));

;// CONCATENATED MODULE: ./src/views/Predictions/index.tsx



// import testSvg from './components/BG_TOP.svg'
// import { useModal, useMatchBreakpoints, BG_TOP } from '@pancakeswap/uikit'



















function Warnings() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChartDisclaimerShow */.TL)(), 1), showDisclaimer = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPredictionChainlinkChartDisclaimerShow */.sg)(), 1), showChainlinkDisclaimer = ref1[0];
    var isChartPaneOpen = (0,predictions_hooks/* useIsChartPaneOpen */.YF)();
    var chartView = (0,predictions_hooks/* useChartView */.WR)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChartDisclaimer, {}), false), 1), onPresentChartDisclaimer = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ChainlinkChartDisclaimer, {}), false), 1), onPresentChainlinkChartDisclaimer = ref3[0];
    // TODO: memoize modal's handlers
    var onPresentChartDisclaimerRef = (0,react.useRef)(onPresentChartDisclaimer);
    var onPresentChainlinkChartDisclaimerRef = (0,react.useRef)(onPresentChainlinkChartDisclaimer);
    // Chart Disclaimer
    (0,react.useEffect)(function() {
        if (isChartPaneOpen && showDisclaimer && chartView === types/* PredictionsChartView.TradingView */.RU.TradingView) {
            onPresentChartDisclaimerRef.current();
        }
    }, [
        onPresentChartDisclaimerRef,
        isChartPaneOpen,
        showDisclaimer,
        chartView
    ]);
    // Chainlink Disclaimer
    (0,react.useEffect)(function() {
        if (isChartPaneOpen && showChainlinkDisclaimer && chartView === types/* PredictionsChartView.Chainlink */.RU.Chainlink) {
            onPresentChainlinkChartDisclaimerRef.current();
        }
    }, [
        onPresentChainlinkChartDisclaimerRef,
        isChartPaneOpen,
        showChainlinkDisclaimer,
        chartView
    ]);
    return null;
}
var Predictions = function() {
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var initialBlock = (0,hooks/* useInitialBlock */.Xh)();
    var currentEpoch = (0,predictions_hooks/* useGetCurrentEpoch */.dJ)();
    useAccountLocalEventListener();
    (0,react.useEffect)(function() {
        if (initialBlock > 0) {
            // Do not start initialization until the first block has been retrieved
            dispatch((0,predictions/* initializePredictions */.uw)(account));
        }
    }, [
        initialBlock,
        dispatch,
        account
    ]);
    (0,react.useEffect)(function() {
        if (account) {
            dispatch((0,predictions/* fetchNodeHistory */.uP)({
                account: account
            }));
        }
    }, [
        account,
        currentEpoch
    ]);
    hooks_usePollPredictions();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Warnings, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RiskDisclaimer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperProvider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container, {
                    children: [
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Desktop, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Mobile, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectWinningsPopup, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var views_Predictions = (Predictions);


/***/ })

}]);